export default {
    "切换会话": 1,
    "切换会话并滚动值顶部": 2,
    "定位某一条会话功能": 3,
    "定位某一条准确消息功能": 4,
    "定位某一条会话不需要检查群公告编辑状态以及窗口状态": 5,
    "定位某一条会话不需要检查窗口状态": 6,
    "站内信": 7,
    "邮件": 8,
    "短信": 9,
    "全部": 10,
    "企业客户": 11,
    "自然人客户": 12,
    "中介机构": 13,
    "潜在客户": 14,
    "已投客户": 15,
    "初步洽谈": 16,
    "达成合作": 17,
    "协议签署": 18,
    "会计师事务所": 19,
    "律师事务所": 20,
    "资产评估机构": 21,
    "信用评级机构": 22,
    "券商机构": 23,
    "未上市": 24,
    "主板": 25,
    "中小板": 26,
    "创业板": 27,
    "新三板": 28,
    "科创板": 29,
    "其他": 30,
    "自然人": 31,
    "法人": 32,
    "已通过": 33,
    "审批中": 34,
    "未通过": 35,
    "已撤销": 36,
    "有条件通过": 37,
    "暂缓表决": 38,
    "普通": 39,
    "紧急": 40,
    "非常紧急": 41,
    "正常": 42,
    "已逾期": 43,
    "未完成": 44,
    "已完成": 45,
    "已关闭": 46,
    "未读": 47,
    "已读": 48,
    "登录状态已失效需要跳到登录页面": 49,
    "登录过期，请重新登录！": 50,
    "网络异常！": 51,
    "项目id不存在 如果看到此错误 请在群里说一下复现步骤": 52,
    "userId为空 如果看到此错误 请在群里说一下复现步骤": 53,
    "任务已删除": 54,
    "名称中不能包含下列特殊字符“\\\\/:*?\"<>|”": 55,
    "暂无对应权限，请联系管理员！": 56,
    "当前无选中文件或文件夹": 57,
    "独立窗口数量已达上限，请关闭其他已打开窗口再操作": 58,
    "项目不存在": 59,
    "组织不存在": 60,
    "荣大XB文件不允许更新版本，请选择重命名或跳过": 61,
    "存在文件与文件夹重名，请选择重命名或跳过": 62,
    "提示": 63,
    "确定要取消上传所有文件吗？": 64,
    "确定": 65,
    "取消": 66,
    "文件已被删除": 67,
    "确定解除「手动锁定」的文件吗？": 68,
    "解除锁定后将通过站内信向锁定人「{}」发送文件解锁提醒。确定继续解锁吗？": 69,
    "解锁": 70,
    "暂无权限解除他人「手动锁定」的文件": 71,
    "请联系锁定人 【{}】进行解除锁定": 72,
    "解锁失败": 73,
    "我知道了": 74,
    "确定（{}秒）": 75,
    "确定要解锁该文件吗？": 76,
    "该文件可能正在编辑，解锁后，完成的版本需要手动上传，同时手动上传的版本内容将覆盖他人编辑的内容，确定要解锁吗？": 77,
    "确定解锁此文件吗？": 78,
    "检测到此文件未在编辑状态，文件锁定异常。": 79,
    "如确定文件正在编辑，请在完成编辑后检查文件已更新为编辑内容。确定继续解锁吗？": 80,
    "暂无权限解除他人正在进行「本地编辑」的文件。": 81,
    "不支持手动解除「审批中/审批通过」的文件": 82,
    "当文件审批被驳回或审批通过后，发起修订时将自动解锁": 83,
    "此文件正在被{}人编辑，不支持解锁他人正在进行「在线编辑」的文件，文件将在所有人完成编辑后自动解锁。": 84,
    "文件锁定异常，且无人正在编辑当前文件，确定要继续解锁吗？": 85,
    "文件锁定异常，且无人正在编辑当前文件，请联系项目管理员进行解锁": 86,
    "联系项目管理员": 87,
    "此文件已被系统锁定，可以预览/只读方式打开！": 88,
    "如需要编辑文件，请下载文件至本地。": 89,
    "此文件已经被": 90,
    "锁定，可以预览/只读方式打开！": 91,
    "文件大于 1G 不支持在线编辑！": 92,
    "文件正在进行本地编辑，请先保存后再进行在线编辑操作！": 93,
    "知道了": 94,
    "该文件已锁定，解锁后才能进行编辑，确定要解锁并进行编辑吗？": 95,
    "该文件格式不支持在线编辑，请通过本地编辑或下载后编辑！": 96,
    "文件正在进行在线编辑，请先保存后再进行本地编辑操作！": 97,
    "参数校验失败，请联系管理员！": 98,
    "网络异常": 99,
    "荣大智慧云": 100,
    "预览": 101,
    "该文件类型暂不支持预览，请下载查看！": 102,
    "【荣大智慧云】的下载文件.xlsx": 103,
    "文档导出错误": 104,
    "搜狗": 105,
    "当前项目已终止，不可进行此操作": 106,
    "服务繁忙，请稍后重试": 107,
    "获取行业分类错误， \\'{}": 108,
    "正在打开页面。。。": 109,
    "获取媒体信息错误，请稍后再试。": 110,
    "编辑": 111,
    "只读查看": 112,
    "请下载查看！": 113,
    "是否通过本地应用打开查看？": 114,
    "是否下载到本地？": 115,
    "下载": 116,
    "只读打开": 117,
    "此文件类型暂不支持编辑与预览，可通过“只读”方式打开文件或将文件下载至本地查看。": 118,
    "只读": 119,
    "当前上传图片已超过最大限制": 120,
    "今天": 121,
    "昨天": 122,
    "前天": 123,
    "MM月DD日": 124,
    "YYYY年MM月DD日": 125,
    "该附件已被删除": 126,
    "我的日志": 127,
    "确定要复用日志吗？": 128,
    "确定要新建日志吗？": 129,
    "有正在编辑的草稿内容，该操作将清空已有的草稿内容，确定继续操作吗？": 130,
    "编辑草稿": 131,
    "网络异常，请刷新重试": 132,
    "共移动 {} 个文件": 133,
    "我是目标文件": 134,
    "目标文件夹与源文件夹相同": 135,
    "目标文件夹含有源文件夹的子文件夹": 136,
    "目标文件夹为\"全部\"文件夹": 137,
    "文件无法操作，已选中的文件或文件夹包含已锁定状态": 138,
    "选中数量超过{}条，请减少操作数量": 139,
    "移动 {} 个文件": 140,
    "发送指定聊天": 141,
    "发送至项目聊天": 142,
    "全局检索": 143,
    "无对应权限，请联系对应项目组负责人处理": 144,
    "系统异常，请刷新重试": 145,
    "当前无权限": 146,
    "{}已存在": 147,
    "文件夹": 148,
    "文件": 149,
    "\"{}\"于{}正在编辑文件": 150,
    "\"{}\"于{}锁定文件": 151,
    "{}审批通过已被锁定": 152,
    "\"{}\"于{}对该{}发起审批": 153,
    "未正常退出，请重新双击进入编辑，待所有人再次退出后系统自动解锁": 154,
    "多人在线编辑模式": 155,
    "单人本地编辑": 156,
    "该文件切换模式错误，请检查网络无问题后重试": 157,
    "当前最多仅支持选择 {} 人，超出人员不计入选择！": 158,
    "文件夹名称包含特殊字符，请修改文件夹名称后再上传": 159,
    "文件名称包含特殊字符，请修改文件名称后再上传": 160,
    "无内容": 161,
    "文件超出下载限制（已超出600MB/不支持多文件下载），建议使用荣大智慧云客户端进行下载": 162,
    "未检测到荣大智慧云客户端，如果未安装客户端，请先下载安装": 163,
    "下载荣大智慧云客户端": 164,
    "重新检测本地客户端": 165,
    "下载Apple芯片版本": 166,
    "下载Intel芯片版本": 167,
    "正在启动，请稍后": 168,
    "附件": 169,
    "删除失败": 170,
    "已选中的内容中包含已锁定的文件，请先解锁后再进行删除": 171,
    "去解锁": 172,
    "请先加入项目群": 173,
    "消息": 174,
    "项目": 175,
    "文档": 176,
    "任务": 177,
    "工作台": 178,
    "通讯录": 179,
    "投关": 180,
    "应用中心": 181,
    "项目列表": 182,
    "项目归档库": 183,
    "项目终止库": 184,
    "项目回收站": 185,
    "标签管理": 186,
    "项目文档": 187,
    "底稿视图": 188,
    "回收站": 189,
    "文件收藏": 190,
    "个人网盘": 191,
    "我的任务": 192,
    "项目任务": 193,
    "主页": 194,
    "项目统计": 195,
    "日历表": 196,
    "待办事项": 197,
    "我的审批": 198,
    "我的会议": 199,
    "我的投票": 200,
    "我的客户": 201,
    "客户联系人": 202,
    "拜访记录": 203,
    "项目成员": 204,
    "项目日志": 205,
    "项目信息": 206,
    "项目审批": 207,
    "项目会议": 208,
    "项目投票": 209,
    "打开独立窗口": 210,
    "从导航栏移除": 211,
    "设为首页打开": 212,
    "显示应用名称": 213,
    "自定义导航菜单": 214,
    "定位": 215,
    "另存为": 216,
    "打开": 217,
    "投票详情": 218,
    "所属项目": 219,
    "投票名称": 220,
    "投票类型": 221,
    "投票时间": 222,
    "提醒方式": 223,
    "投票人员": 224,
    "抄送人员": 225,
    "日程名称": 226,
    "人员": 227,
    "时间": 228,
    "重复": 229,
    "内容": 230,
    "抄送人": 231,
    "任务详情": 232,
    "任务名称": 233,
    "截止时间": 234,
    "项目名称": 235,
    "状态": 236,
    "创建时间": 237,
    "会议详情": 238,
    "参会人员": 239,
    "列席人员": 240,
    "会议主题": 241,
    "会议类型": 242,
    "会议地点": 243,
    "会议抄送人": 244,
    "会议内容": 245,
    "日程": 246,
    "投票": 247,
    "会议": 248,
    "日志": 249,
    "修改": 250,
    "无提醒": 251,
    "提前15分钟": 252,
    "提前1小时": 253,
    "提前3小时": 254,
    "提前1天": 255,
    "不重复": 256,
    "每天": 257,
    "每周": 258,
    "每年": 259,
    "工作日": 260,
    "不提醒": 261,
    "截至前15分钟": 262,
    "截至前1小时": 263,
    "截至前3小时": 264,
    "截至前1天": 265,
    "剪切": 266,
    "复制": 267,
    "重命名": 268,
    "删除": 269,
    "粘贴": 270,
    "预览打开": 271,
    "多人编辑": 272,
    "通过浏览器在线打开该文件，支持多人同时编辑": 273,
    "发送到指定聊天": 274,
    "发送到项目聊天": 275,
    "发送到聊天": 276,
    "Excel格式": 277,
    "外链分享": 278,
    "生成文件链接，任意人员可通过该链接预览、下载该文件": 279,
    "上传新版本": 280,
    "版本": 281,
    "属性": 282,
    "操作日志": 283,
    "锁定": 284,
    "锁定当前文件，文件被锁定后他人不可编辑": 285,
    "保存到个人网盘": 286,
    "解除锁定，编辑过程中不建议解锁，否则将导致现有编辑内容无法保存上传": 287,
    "添加至「文件收藏」": 288,
    "批量上锁": 289,
    "批量解锁": 290,
    "解锁当前所选文件,以及文件夹下所有的文件": 291,
    "文件审批": 292,
    "文件标签": 293,
    "关联底稿": 294,
    "文件审批意见": 295,
    "文件修订": 296,
    "关联索引列表": 297,
    "设置提醒": 298,
    "核查备注": 299,
    "本地编辑": 300,
    "使用本地编辑器打开该文件，仅支持单人编辑": 301,
    "打开任务": 302,
    "新建文件夹": 303,
    "新建任务文件夹": 304,
    "上传文件": 305,
    "上传文件夹": 306,
    "Word文档": 307,
    "Excel表格": 308,
    "PPT演示": 309,
    "导出清洁版": 310,
    "新建文件": 311,
    "目录审批": 312,
    "目录审批意见": 313,
    "目录修订": 314,
    "更多": 315,
    "下载核查报告": 316,
    "文件工具箱介绍": 317,
    "Excel检验文件目录": 318,
    "Excel提取并复制文件": 319,
    "导出文件目录": 320,
    "文件工具箱": 321,
    "该部门已被删除": 322,
    "有文件正在上传，页面切换或刷新将导致文件上传取消。是否继续？": 323,
    "定制页面切换普通页面": 324,
    "普通页面切换到定制页面": 325,
    "定制页面跳转至定制页面": 326,
    "上市公司": 327,
    "拟上市公司": 328,
    "有限责任公司": 329,
    "股份有限公司": 330,
    "股份合作企业": 331,
    "国有企业": 332,
    "集体所有制": 333,
    "个体工商户": 334,
    "独资企业": 335,
    "有限合伙": 336,
    "普通合伙": 337,
    "外商投资企业": 338,
    "港、澳、台商投资企业": 339,
    "联营企业": 340,
    "私营企业": 341,
    "其他浏览器": 342,
    "项目类型": 343,
    "普通审批": 344,
    "审批流程名称": 345,
    "审批类型": 346,
    "业务类型": 347,
    "项目阶段": 348,
    "流程描述": 349,
    "是否可用": 350,
    "可用": 351,
    "不可用": 352,
    "不可用原因": 353,
    "请输入审批流程名称": 354,
    "请选择审批类型": 355,
    "底稿审批": 356,
    "阶段审批": 357,
    "项目终止审批": 358,
    "新建项目审批": 359,
    "底稿归档审批": 360,
    "底稿借阅审批": 361,
    "文件修订审批": 362,
    "底稿目录修订审批": 363,
    "无": 364,
    "项目所属阶段与流程图所属业务类型不匹配": 365,
    "待审文件": 366,
    "请到项目文档中发起审批": 367,
    "项目所属阶段与流程图所属阶段不匹配": 368,
    "当前项目正在进行阶段审核": 369,
    "这是个错误提示！": 370,
    "这是个正确提示！": 371,
    "当前账号在其他设备登录，如果不是本人操作，请及时修改登录密码": 372,
    "登录状态已失效，需要跳转登录页面重新登录": 373,
    "图片": 374,
    "群公告": 375,
    "分享了一个任务": 376,
    "重置数据": 377,
    "单独设置某一个会话": 378,
    "批量设置会话操作": 379,
    "单条会话移除": 380,
    "免打扰状态切换": 381,
    "接受某条消息后处理": 382,
    "重新登录后对托盘所有消息进行重置": 383,
    "会话已读的操作,需要删除与sessionid相关忽略、@消息、托盘等数据": 384,
    "全部任务": 385,
    "全部项目": 386,
    "消息会话": 387,
    "消息记录": 388,
    "讨论文件合集": 389,
    "Word文件（非XB）": 390,
    "表格文件": 391,
    "演示文件": 392,
    "PDF文件": 393,
    "TXT文件": 394,
    "图片文件": 395,
    "视频文件": 396,
    "音频文件": 397,
    "荣大XB文件": 398,
    "外部XB文件": 399,
    "其它": 400,
    "有索引的": 401,
    "无索引的": 402,
    "已锁定": 403,
    "有备注的": 404,
    "有标签的": 405,
    "待审批": 406,
    "审批通过": 407,
    "节点审批通过": 408,
    "驳回未修改": 409,
    "驳回已修改": 410,
    "修订中": 411,
    "修订审批中": 412,
    "有关联的": 413,
    "有审批记录的": 414,
    "有设置提醒的": 415,
    "已归档": 416,
    "无文件": 417,
    "有文件": 418,
    "引用目录": 419,
    "非引用目录": 420,
    "项目名称或项目ID": 421,
    "项目创建人": 422,
    "选择部门": 423,
    "项目地区": 424,
    "当前阶段": 425,
    "创建日期": 426,
    "关联客户": 427,
    "关联项目": 428,
    "行业分类": 429,
    "项目负责人": 430,
    "文件名称": 431,
    "标题关键词": 432,
    "内容关键词": 433,
    "文件类型": 434,
    "文件状态": 435,
    "目录状态": 436,
    "修改时间起": 437,
    "修改时间止": 438,
    "创建人": 439,
    "执行人": 440,
    "优先级": 441,
    "逾期状态": 442,
    "任务状态": 443,
    "任务时间起": 444,
    "任务时间止": 445,
    "日志标题": 446,
    "日志内容": 447,
    "发出人员": 448,
    "日志状态": 449,
    "日志评论": 450,
    "日志评论人": 451,
    "日志接收人": 452,
    "个人日志": 453,
    "客户编码": 454,
    "客户名称": 455,
    "客户类型": 456,
    "客户状态": 457,
    "上市板块": 458,
    "客户负责人": 459,
    "客户创建人": 460,
    "机构编码": 461,
    "机构名称": 462,
    "机构简称": 463,
    "机构类型": 464,
    "部门": 465,
    "职务": 466,
    "拜访开始时间": 467,
    "拜访结束时间": 468,
    "拜访地点": 469,
    "拜访人员": 470,
    "拜访形式": 471,
    "主要成果": 472,
    "请输入项目名称,多个请用空格隔开": 473,
    "请选择项目成员": 474,
    "请选择阶段": 475,
    "点击选择项目创建人": 476,
    "点击选择项目负责人": 477,
    "请选择起始时间": 478,
    "请选择终止时间": 479,
    "请输入客户名称,多个请用空格隔开": 480,
    "共 {} 条 (最多可查看前 10,000 条数据)": 481,
    "共 {} 条": 482,
    "我的联系人": 483,
    "客户管理": 484,
    "联系人管理": 485,
    "联系人信息查阅授权": 486,
    "通讯录操作记录": 487,
    "正在粘贴...": 488,
    "摘要": 489,
    "外链": 490,
    "不限大小": 491,
    "10M以内": 492,
    "大于100M": 493,
    "自定义": 494,
    "第一步：点击「新建任务」": 495,
    "在这里可以开始新建任务并进行网查任务相关的配置信息": 496,
    "第二步：输入任务基本信息": 497,
    "在这里你可以输入需要进行的网查任务名称，并将该任务与项目进行关联": 498,
    "第三步：下载并导入网查清单": 499,
    "1、将下载模板后，按照对应格式填写相关信息，再将完善好的表格进行上传": 500,
    "2、选择各个分类下所需要查询的省市级网站及海关信息，完成配置后点击「确定并继续」": 501,
    "第四步：配置查询网站": 502,
    "在这里你可以选择不同分类下需要查询的网站，或添加其他网站，完成后点击「确认并继续」": 503,
    "第五步：启动网查任务": 504,
    "任务配置完成后，在当前页面可查看本次任务的查询数量及权益信息，点击「立即启动」后网查任务自动开始": 505,
    "第六步：查看任务详情": 506,
    "在这里你可以查看当前网查任务下查询的子任务的更新状态": 507,
    "第七步：查看完成查询的任务文件": 508,
    "在点击「查看文件」跳转至网查任务所在的项目文件夹": 509,
    "第八步：查看项目文件": 510,
    "已完成查询的任务文件会自动存储在当前项目>智能网查文件夹内。": 511,
    "现在，你已经完成了智能网查工具的核心功能流程使用，现在去创建自己的网查任务吧": 512,
    "转发": 513,
    "新建": 514,
    "任务文件夹": 515,
    "在线模板": 516,
    "目录模板": 517,
    "底稿变动记录": 518,
    "上传": 519,
    "设置上传路径": 520,
    "批量关联底稿": 521,
    "文件内容": 522,
    "请输入文件内容关键字 以空格区分": 523,
    "修改时间": 524,
    "今日": 525,
    "近一周内": 526,
    "近一个月内": 527,
    "近三个月内": 528,
    "近六个月内": 529,
    "近一年内": 530,
    "非": 531,
    "在线编辑": 532,
    "在线预览": 533,
    "XB导出清洁版": 534,
    "内容关键字": 535,
    "多人在线编辑": 536,
    "任务中暂不支持单人本地编辑，请切换到多人在线编辑，或定位至源文件位置操作": 537,
    "目标文件已被锁定，暂不支持编辑，鼠标移入锁图标查看详情。如需继续操作请联系相关人员解锁或下载该文件": 538,
    "请选择至少一条数据": 539,
    "请选择一条数据": 540,
    "文件夹不能预览，请选择文件": 541,
    "审批中的文件不能重命名，请重新选择。": 542,
    "归档文件不可重命名": 543,
    "该文件不允许重命名": 544,
    "文件正在进行在线编辑不能进行此操作": 545,
    "不能包含特殊字符/:*?\"<>|": 546,
    "已有相同名称的{}，是否以 {} 命名{}": 547,
    "目录": 548,
    "重名提示": 549,
    "文件已锁定，不允许上传新版本": 550,
    "归档文件不可上传新版本": 551,
    "文件夹不支持该功能，请选择文件": 552,
    "荣大XB文件不支持查看版本": 553,
    "权限校验失败,请联系管理员": 554,
    "当前项目已终止,不可以进行此操作": 555,
    "文件已经被系统锁定,不允许执行此操作": 556,
    "文件已经归档,不允许执行此操作": 557,
    "当前数据不完整,请联系管理员": 558,
    "智慧投行管理系统": 559,
    "修改密码": 560,
    "切换后台": 561,
    "一键同步": 562,
    "退出登录": 563,
    "个人信息": 564,
    "欢迎您": 565,
    "项目编码": 566,
    "项目状态": 567,
    "操作": 568,
    "上传新文件": 569,
    "初始化": 570,
    "未上传": 571,
    "上传成功": 572,
    "上传失败": 573,
    "初始化完成，等待上传": 574,
    "不同意": 575,
    "不通过": 576,
    "驳回": 577,
    "请输入项目名称": 578,
    "未设置执行人": 579,
    "未设置抄送人": 580,
    "任务时间": 581,
    "当前为内测环境，即将跳转到正式环境，若仍需要使用内测环境，请联系 {} 进行咨询": 582,
    "当前为正式环境，即将跳转到内测环境，若仍需要使用正式环境，请联系 {} 进行咨询": 583,
    "投行机构": 584,
    "创建一个组织/项目": 585,
    "建立一个IPO项目并添加团队成员": 586,
    "欢迎来到智慧云，创建一个组织/项目是开启投行工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置": 587,
    "日常沟通协作": 588,
    "围绕项目文件协作展开的高效沟通": 589,
    "无论是券商收集发行人的申报材料，或发行人准备上市材料等与文件协作相关的场景，都可以通过智慧云的「发送到聊天」功能对项目文件进行针对性的沟通，在消息中讨论的所有过程文件都会被留痕，让工作有源可溯、有迹可循": 590,
    "项目文件管理": 591,
    "收集发行人资料、整理底稿、撰写招股说明书": 592,
    "智慧云预置了最新的项目底稿文件模板，可以在线一键导入，并按照底稿目录的要求实时收集发行人的底稿材料。同时可以对常见文件类型进行在线多人编辑或单人本地编辑，提高文件整理效率": 593,
    "任务分配": 594,
    "通过任务分配把控项目整体进度": 595,
    "创建或导入项目进行中各阶段的任务，方便对项目过程中的事项集中管理，有序规划工作节奏，及时了解项目任务的执行进展，尽早规避潜在风险。成员可以将任务分享至其他成员，与团队成员协作完成任务，共同达成团队目标": 596,
    "实习生管理": 597,
    "对项目角色进行权限分配，将敏感数据有效隔离": 598,
    "在项目承做过程中需要进行数据隔离或不希望部分角色接触到核心数据时，可以在智慧云中通过任务分发的方式进行数据隔离并完成项目任务，或对项目角色进行可操作/查看内容范围的权限配置，对于即将退出或已经退出项目的成员可以做到数据的有效隔离": 599,
    "质控内核": 600,
    "区分过程文件目录与底稿目录，支持文件外批注，支持导出批注": 601,
    "在项目的质控与内核过程中，你可以在智慧云内通过将项目文档按团队或分工的形式建立不同的文件目录开展相对应的工作，通过底稿视图索引项目文件生成底稿目录快速有效的区分过程文件与底稿文件，同时支持对文件进行批注与导出。": 602,
    "专业的应用程序": 603,
    "穿行测试PDF文件解析、智能网查、走访盘点相机、XBRL等应用程序": 604,
    "智慧云「应用中心」是一个精心打造的集成了各种类型与项目相关的应用集合工作台，在这里你可以通过丰富独立的应用程序来解决在项目全流程上的多种业务场景问题，快速整合申报信息从而提高团队工作效率，让成员更省心，管理者更放心": 605,
    "私募基金": 606,
    "建立一个属于自己公司机构类型的组织并添加团队成员": 607,
    "欢迎来到智慧云，创建一个组织/项目是开启基金管理工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置": 608,
    "全生命周期管理": 609,
    "任务清单式的全生命周期项目管理": 610,
    "你可以通过智慧云实现私募基金的全生命周期管理，通过任务式清单建立开放高效的协作体系，在任务看板中即可随时掌握所有产品进度，再多产品并行也能及时把控，任务完成后产出的文件会自动归集为项目文件，过程资料将自动归档，无需事后补充或二次核查，让项目管理更高效": 611,
    "围绕基金产品的项目任务展开内外部高效沟通协作": 612,
    "多部门协作的产品要素表制作或合同要素信息、估值表、投资者信息的分享，都可以通过智慧云在线讨论功能对项目文件进行针对性的沟通，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循。亦或基金合同状态查询，也可通过项目伴生群时时接收最新合同动态": 613,
    "基金合同状态查询": 614,
    "一站式查询所有基金产品合同状态及信息": 615,
    "基金合同或其他文件可以通过项目的形式进行管理，项目创建完成会自动生成对应的项目伴生群，在项目伴生群内有关基金合同的所有信息可以随时随地在手机端或电脑端进行查看实时信息或历史信息": 616,
    "发行人(上市/拟上市公司)": 617,
    "创建一个IPO项目": 618,
    "建立一个企业IPO项目并添加团队成员": 619,
    "欢迎来到智慧云，建立一个组织/项目是开启IPO工作的必要前提，作为组织/项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置": 620,
    "无论是券商机构收集发行人的申报材料，或发行人准备上市材料等与文件协作相关的场景，都可以通过智慧云的「发送到聊天」功能对项目文件进行针对性的沟通，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循": 621,
    "文件高效传递/协作": 622,
    "避免反复向多方提供文件，文件变更后自动同步，无需二次传递": 623,
    "发行人上市过程中忙于经营，在券商机构承做上市申报材料时，为避免包含同一数据或需要反复引用的文件在多方传递或被修改后由于更新版本不一致而影响申报材料制作，可以将所有项目文件在智慧云内进行统一管理，当原始文件数据更新后，所有相关文件将同步更新，避免因文件材料无效而影响整体上市进度": 624,
    "分配任务进行资料收集管理": 625,
    "董秘办分配任务到各部门，附带文件模板，自动归集产出文件": 626,
    "在企业上市前夕需要相关负责人来协调统筹上市工作所需要的所有材料文件，智慧云预置了上市过程中各阶段的任务模板，负责人可以通过任务分享的方式在企业内部快速收集所需的文件材料，分配给执行人的任务可以附带文件模板说明及注意事项，更精确有效的归集文件，任务完成后产出的文件会自动归集为项目文件，省去二次整理的时间，让任务管理更高效": 627,
    "项目文件操作留痕": 628,
    "记录与文件相关的操作，并生成统计简报定期推送": 629,
    "为更好的管理上市前夕内部的材料准备，部门协作人对上级分发的任务完成情况，或项目内文件的操作动态可以通过每日简报获取相关的操作数据，文件留痕使过程容易被追溯": 630,
    "专业应用": 631,
    "董监高辅导验收模拟考试（IPO版驾考宝典）": 632,
    "智慧云「应用中心」是一个精心打造的集成了各种类型与项目相关的应用集合工作台，在这里你可以通过丰富独立的应用程序来解决项目上市过程中的多种业务场景题，快速整合申报信息从而提高团队工作效率，让成员更省心，管理者更放心": 633,
    "企业内部管理": 634,
    "按事物或部门创建项目": 635,
    "创建一个契合你部门或事物的项目并添加团队成员": 636,
    "欢迎来到智慧云，建立一个项目是开启企业内部管理工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在项目的全部权限，可以对不同角色的项目成员进行权限配置": 637,
    "新成员可查看历史消息，提高工作交接效率": 638,
    "智慧云提供了针对项目文件进行的实时讨论功能，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循，为所有参与项目的成员了解历史信息提供了便捷的帮助": 639,
    "基于项目管理文件，持续积累沉淀形成企业内部知识库": 640,
    "智慧云提供了基于项目文件的模板配置功能，你可以通过配置生成统一的文件模板，协作成员可以对文件进行在线同步编辑或单人本地编辑，在不断的积累沉淀过程中形成企业内部的知识库": 641,
    "通过任务分配把控项目整体进度，共同达成团队目标": 642,
    "创建或导入需要工作协同的任务，将任务分享至相关的执行人进行协同，分配给执行人的任务可以附带相关文件说明及注意事项，更精确有效的传达任务目标，任务完成后产出的文件会自动归集为项目文件，在把控团队执行进度的同时，使工作目标可以更有效完成规划": 643,
    "集团客户管理": 644,
    "建立项目层级，管理层级关系复杂的集团客户": 645,
    "对层级关系复杂的企业，可以通过真实的组织架构进行项目分层级管理，使项目预览更加高效，同时对常参与的项目可以进行收藏管理，方便用户一键触达对应项目内": 646,
    "企业管理权限设置": 647,
    "无需参与项目，按部门或按业务类型查阅所有项目": 648,
    "企业管理员可以通过后台管理对组织内不同成员角色进行可访问数据和可操作功能的权限配置，可以有效的对不同成员进行数据隔离，防止潜在风险发生": 649,
    "包含证券公司、律所、会所等机构对投行项目的日常管理操作": 650,
    "基金产品全生命周期管理": 651,
    "项目申报中的文件传递、日常沟通、分配任务等，所有工作都聚合一处": 652,
    "团队及日常工作事物一站式管理": 653,
    "项目设置": 654,
    "项目名备注": 655,
    "添加至收藏": 656,
    "取消收藏": 657,
    "添加至「收藏」": 658,
    "失败": 659,
    "文件名": 660,
    "编辑模式": 661,
    "修改人": 662,
    "大小": 663,
    "文件路径": 664,
    "新建子文件夹": 665,
    "上传新版本成功！": 666,
    "时间从近到远": 667,
    "时间从远到近": 668,
    "文件从大到小": 669,
    "文件从小到大": 670,
    "多文件": 671,
    "编辑打开": 672,
    "文件格式错误，无法另存！": 673,
    "您已不在该组织，请选择其它保存位置": 674,
    "您已不在该项目，请选择其它保存位置": 675,
    "审批流程": 676,
    "请输入审批流程名称,多个请用空格隔开": 677,
    "申请内容": 678,
    "请输入申请内容,多个请用空格隔开": 679,
    "交接人员": 680,
    "审核中": 681,
    "底稿": 682,
    "审批": 683,
    "参考文件": 684,
    "调查工具": 685,
    "自然日": 686,
    "一": 687,
    "二": 688,
    "三": 689,
    "四": 690,
    "五": 691,
    "六": 692,
    "日": 693,
    "截止前15分钟": 694,
    "截止前1小时": 695,
    "截止前3小时": 696,
    "截止前1天": 697,
    "开始前一天": 698,
    "开始时": 699,
    "完成时": 700,
    "应用内消息": 701,
    "Excel文档": 702,
    "PPT文档": 703,
    "Txt文档": 704,
    "确认要把文件放入回收站吗?删除的文件可随时通过回收站还原。": 705,
    "已取消删除": 706,
    "删除成功！": 707,
    "当前页不可重命名": 708,
    "只能重命名一个": 709,
    "请选择想要剪切的文件或文件夹": 710,
    "剪切成功!": 711,
    "复制成功!": 712,
    "当前页不可粘贴": 713,
    "请先复制或剪切": 714,
    "粘贴内容超出网盘容量": 715,
    "可用空间已满": 716,
    "新建{}文档": 717,
    "新建失败": 718,
    "只能对一个文件上传新版本": 719,
    "文件夹不支持上传新版本，请选择文件": 720,
    "解锁文件夹下所有的文件": 721,
    "文件已另存到": 722,
    "去查看": 723,
    "另存失败，请重新操作": 724,
    "文件上传失败": 725,
    "因当前空间不足，导致文件上传失败": 726,
    "因当前空间不足，导致文件上传失败 ；请联系": 727,
    "进行空间查询与管理": 728,
    "空间查询": 729,
    "升级扩容": 730,
    "因当前空间不足，导致文件上传失败；请进行空间查询与管理!": 731,
    "当前只可选择文件": 732,
    "文件较大，正在另存中...": 733,
    "个人网盘空间不足": 734,
    "未选中文件": 735,
    "未选中文件夹": 736,
    "当前目录不可选择,请重新选择目录": 737,
    "讨论文件合集({}项)": 738,
    "等{}个文件,": 739,
    "评论了您的日志": 740,
    "在日志中@了您": 741,
    "回复了您的日志": 742,
    "加载中...": 743,
    "你可以将文件直接拖拽到这里，或者点击": 744,
    "审批催办": 745,
    "查看详情": 746,
    "接收范围": 747,
    "开始时间": 748,
    "结束时间": 749,
    "地址": 750,
    "至": 751,
    "等": 752,
    "限时免费": 753,
    "限时特惠": 754,
    "文件/文件夹数据过多、不支持上传、建议分批多次上传": 755,
    "暂无可查看任务": 756,
    "请前往项目任务查看任务，可同时打开10个任务": 757,
    "查看项目任务": 758,
    "还原": 759,
    "放大": 760,
    "关闭": 761,
    "播放": 762,
    "公告的图片": 763,
    "查看全文": 764,
    "查看": 765,
    "当前文件版本已发生变更，请选择你要操作的文件版本": 766,
    "历史版本": 767,
    "当前版本": 768,
    "[文件]": 769,
    "[文件夹]": 770,
    "打开文件夹": 771,
    "月": 772,
    "最近修改": 773,
    "下载最新文档": 774,
    "讨论文件合集({})项": 775,
    "消息已被撤回": 776,
    "来源于": 777,
    "语音": 778,
    "@所有人": 779,
    "选择执行人": 780,
    "来自": 781,
    "选择开始时间": 782,
    "选择结束时间": 783,
    "任务标签": 784,
    "查看更多": 785,
    "设为前置": 786,
    "取消前置": 787,
    "详情": 788,
    "重新编辑": 789,
    "任务已被删除": 790,
    "点击查看": 791,
    "你": 792,
    "分享了一篇日志": 793,
    "查看全部": 794,
    "评论": 795,
    "】来源于:": 796,
    "讨论": 797,
    "相关任务": 798,
    "文件权限": 799,
    "Txt文本": 800,
    "请切换到主窗口操作此功能": 801,
    "该审批已撤销": 802,
    "您已不在当前审批中，无法查看": 803,
    "关闭和跳转将不会保存你已编辑的群公告内容?": 804,
    "上传失败,仅文件列表区域支持拖拽上传": 805,
    "退出成功!": 806,
    "根目录": 807,
    "XB功能暂不支持使用": 808,
    "您好，您的XBRL已到期。请注意数据中心词条数据将不会同步至XB文档，请及时联系对应商务续费谢谢！": 809,
    "后续不再提示": 810,
    "正在加载...": 811,
    "本科": 812,
    "后退": 813,
    "前进": 814,
    "返回上一级": 815,
    "创建文件夹": 816,
    "联系人/群组": 817,
    "聊天记录": 818,
    "聊天记录中的文件": 819,
    "视频": 820,
    "音频": 821,
    "{}正在播放—荣大智慧云": 822,
    "页面访问权限": 823,
    "查看权限": 824,
    "新建权限": 825,
    "编辑权限": 826,
    "下载与分享权限": 827,
    "文档管理权限": 828,
    "客户权限": 829,
    "联系人权限": 830,
    "通讯录管理权限": 831,
    "项目信息查看": 832,
    "有权访问查看项目信息页面": 833,
    "标签信息编辑": 834,
    "有权编辑项目信息中的标签值": 835,
    "项目信息编辑": 836,
    "有权编辑项目信息内容": 837,
    "中介机构关联": 838,
    "有权增加/移除项目中介机构，并关联机构下相关联系人": 839,
    "联系人查看": 840,
    "有权查看已关联到项目的联系人信息，同时需要拥有组织角色中联系人的查看权限": 841,
    "项目成员管理": 842,
    "有权访问项目【成员管理】页面": 843,
    "成员邀请": 844,
    "有权邀请人员加入当前项目": 845,
    "成员移除": 846,
    "有权移除项目成员": 847,
    "成员加入审核": 848,
    "有权通过/拒绝人员提出加入项目的申请": 849,
    "成员角色设置": 850,
    "有权修改或赋予成员的项目角色，调整成员在项目内的操作权限": 851,
    "项目角色管理": 852,
    "有权访问项目【角色权限】页面": 853,
    "角色权限编辑": 854,
    "有权修改/配置项目角色在项目中的可操作功能": 855,
    "项目角色创建": 856,
    "有权创建新的项目角色": 857,
    "项目角色重命名": 858,
    "有权修改项目角色名称": 859,
    "项目角色删除": 860,
    "有权删除项目角色": 861,
    "项目任务访问": 862,
    "有权访问项目任务页面，查看项目中的任务列表": 863,
    "任务/子任务创建": 864,
    "有权在任务列表中创建新任务，在任务中创建子任务，在文档中创建任务文件夹": 865,
    "全部任务访问": 866,
    "有权查看项目内所有任务信息，无论是否作为任务执行人或被抄送": 867,
    "全部任务编辑": 868,
    "有权编辑项目内所有任务信息，无论是否作为任务执行人或被抄送": 869,
    "全部任务关闭": 870,
    "有权关闭项目内所有任务数据，无论是否作为任务执行人": 871,
    "全部任务删除": 872,
    "有权删除项目内所有任务数据，无论是否作为任务执行人": 873,
    "任务标签管理": 874,
    "有权新增或修改项目内的任务标签": 875,
    "任务工时管理": 876,
    "有权在任务中，设置更新他人任务工时": 877,
    "项目日志访问": 878,
    "有权访问项目日志列表，查看项目内日志数据": 879,
    "项目日志创建": 880,
    "有权在项目中创建新日志，或在【我的日志】中创建所属此项目的日志": 881,
    "项目日志导出": 882,
    "有权将项目日志数据内容导出下载到本地或保存到项目文档": 883,
    "项目日志总览": 884,
    "有权查看项目内所有日志数据，无论是否被抄送": 885,
    "项目会议访问": 886,
    "有权访问查看项目会议列表": 887,
    "项目会议创建": 888,
    "有权在此项目中创建新会议": 889,
    "项目会议编辑": 890,
    "有权在此项目中编辑会议内容": 891,
    "项目会议删除": 892,
    "有权在此项目中删除会议数据": 893,
    "项目会议导出": 894,
    "有权在此项目中导出会议列表": 895,
    "项目投票访问": 896,
    "有权访问查看项目投票列表": 897,
    "项目投票创建": 898,
    "有权在此项目中创建新的投票": 899,
    "项目投票编辑": 900,
    "有权在此项目中编辑投票内容": 901,
    "项目投票删除": 902,
    "有权在此项目中删除投票记录": 903,
    "项目投票导出": 904,
    "有权在此项目中导出投票列表": 905,
    "项目文档访问": 906,
    "有权访问项目中项目文档页面，文件操作权限以配置为准": 907,
    "底稿视图访问": 908,
    "有权访问项目中底稿视图页面，文件操作权限以配置为准": 909,
    "回收站访问": 910,
    "文件预览": 911,
    "在项目文档与底稿视图中，有权预览打开文件": 912,
    "历史版本预览": 913,
    "在项目文档与底稿视图中，有权预览打开文件的历史版本": 914,
    "文件只读": 915,
    "在项目文档与底稿视图中，有权只读打开文件": 916,
    "历史版本只读": 917,
    "在项目文档与底稿视图中，有权只读打开文件的历史版本": 918,
    "文档创建": 919,
    "有权在当前项目文档与底稿视图中新建文件/文件夹/文件目录": 920,
    "文档上传": 921,
    "有权从本地上传文件/文件夹至项目文档或底稿视图": 922,
    "文档粘贴": 923,
    "有权从别的项目/组织中粘贴文件至当前项目文档或底稿视图": 924,
    "本地/在线编辑": 925,
    "有权在项目文档与底稿视图中进行本地/在线编辑文件": 926,
    "文档重命名": 927,
    "有权在项目文档与底稿视图中修改文件/文件夹名称": 928,
    "新版本上传": 929,
    "有权在项目文档与底稿视图中通过本地上传更新文件版本": 930,
    "历史版本还原": 931,
    "有权在项目文档与底稿视图中使用文件历史版本替代当前版本": 932,
    "文档删除": 933,
    "有权在项目文档与底稿视图中进行文件/文件夹删除": 934,
    "文档剪切": 935,
    "有权在项目文档与底稿视图中对文件/文件夹进行剪切操作": 936,
    "有权在底稿视图中通过引用目录模板，替换当前底稿目录": 937,
    "编辑底稿索引": 938,
    "有权在底稿视图中编辑或批量编辑底稿索引": 939,
    "文档下载": 940,
    "有权在项目文档与底稿视图中下载文件/文件夹": 941,
    "历史版本下载": 942,
    "有权在项目文档与底稿视图中下载文件的历史版本": 943,
    "有权在项目文档与底稿视图中将文件/文件夹发送到会话聊天": 944,
    "有权在项目文档与底稿视图中将文件/文件夹通过外链的方式进行分享": 945,
    "文档复制": 946,
    "有权在项目文档与底稿视图中将文件或文件夹进行复制后粘贴至其它项目": 947,
    "有权在项目文档与底稿视图中将文件或文件夹保存副本到个人网盘": 948,
    "文件解锁(管理员)": 949,
    "有权在文档中解锁他人手动上锁文件以及因为网络等原因完成编辑后未能正常解除的文件锁定": 950,
    "文档设置": 951,
    "有权访问文档设置页面，根据文件格式管理文档中，在线编辑功能的使用": 952,
    "有权在文档中发起文件审批": 953,
    "新建项目": 954,
    "有权在组织下新建项目": 955,
    "项目导出": 956,
    "有权在组织下项目列表中进行列表信息导出": 957,
    "项目标签管理": 958,
    "有权新增/编辑删除项目标签数据": 959,
    "项目标签引用": 960,
    "有权在项目中关联项目标签": 961,
    "项目编码修改": 962,
    "有权在组织内项目的项目信息页面，修改项目编码，需要同时拥有项目内编辑信息权限": 963,
    "重复项目筛查": 964,
    "有权在项目列表使用重复项目筛查功能": 965,
    "提交审批": 966,
    "有权在组织下的项目里提交各类审批": 967,
    "项目回收站管理": 968,
    "有权访问项目回收站": 969,
    "项目还原": 970,
    "有权在项目回收站还原已删除的项目": 971,
    "项目终止库管理": 972,
    "有权访问项目终止库": 973,
    "借阅记录": 974,
    "有权在项目归档库中，查看归档项目的借阅记录": 975,
    "查看所有归档项目": 976,
    "有权不经过审批，在项目归档库中直接查看已归档项目": 977,
    "有权查看组织内所有项目的空间占用情况，可以对组织里所有项目的文档回收站进行清空操作": 978,
    "日程抄送人设置": 979,
    "有权在工作台的日历表中，设置日程抄送人": 980,
    "有权在工作台查看组织内的项目统计信息": 981,
    "组织管理": 982,
    "组织管理的相关权限": 983,
    "工作台的相关权限": 984,
    "后台管理": 985,
    "项目信息的相关权限": 986,
    "项目成员的相关权限": 987,
    "项目任务的相关权限": 988,
    "项目日志的相关权限": 989,
    "项目会议的相关权限": 990,
    "项目投票的相关权限": 991,
    "请输入内容": 992,
    "段落": 993,
    "标题1": 994,
    "标题2": 995,
    "标题3": 996,
    "标题4": 997,
    "标题5": 998,
    "标题6": 999,
    "请输入": 1000,
    "请输入任务内容": 1001,
    "请输入注意事项": 1002,
    "s 后自动关闭": 1003,
    "感谢你的反馈！": 1004,
    "你的观点对我们有着至关重要的帮助，你的反馈已被我们高度重视，同时会在接下来提升我们产品体验的过程中被使用": 1005,
    "一般般": 1006,
    "联系人": 1007,
    "普通群": 1008,
    "项目群": 1009,
    "会话": 1010,
    "单聊": 1011,
    "群聊": 1012,
    "左侧边栏导航": 1013,
    "功能栏": 1014,
    "表格列表": 1015,
    "单选右键": 1016,
    "多选右键": 1017,
    "空白区域右键": 1018,
    "列表悬浮按钮": 1019,
    "文件路径导航栏": 1020,
    "文件夹空白页按钮": 1021,
    "项目列表右键操作": 1022,
    "目录树": 1023,
    "另存为弹框": 1024,
    "组织空间": 1025,
    "回收站详情": 1026,
    "输入关键词开始搜索": 1027,
    "暂无内容": 1028,
    "您暂无权限访问，请联系系统管理员进行处理": 1029,
    "当前项目已开启独立窗口": 1030,
    "暂无项目": 1031,
    "新建你的「项目」开启智慧云文档、任务等核心功能，并邀请成员一起在线协作": 1032,
    "多选": 1033,
    "第一个节点下的全选": 1034,
    "其他节点下的全选": 1035,
    "没有用户id": 1036,
    "没有ip权限": 1037,
    "组织列表为空": 1038,
    "项目id记录为空": 1039,
    "请选择日期": 1040,
    "请输入数字": 1041,
    "在线": 1042,
    "忙碌": 1043,
    "离线": 1044,
    "重连恢复在线状态失败, 请刷新重试": 1045,
    "状态修改失败，{}": 1046,
    "[图片]": 1047,
    "文件齐备性校验": 1048,
    "使用Excel文件中的文件名称列，大批量检测目录下是否存在指定文件，检测结果将生成一个单独的控制表。检测完成后，将推送系统消息，检验文件数较多时可能需要等待一定时间": 1049,
    "批量文件快速查找、批量文件重新归档": 1050,
    "使用Excel文件中的文件名称列，以复制文件的方式，大批量提取目录下指定文件到另一个目录，提取结果将保存在一个单独的文件夹当中，并生成控制表。提取完成后，将推送系统消息，提取文件数较多时可能需要等待一定时间": 1051,
    "目录一致性校验、空文件夹批量校验": 1052,
    "选中指定文件夹，导出其下所有文件夹与文件名称，包含格式、上级目录、是否空文件夹。导出完成后，将推送系统消息，导出文件数较多时可能需要等待一定时间": 1053,
    "选择待检验目录": 1054,
    "选择目录文件": 1055,
    "选择待提取目录": 1056,
    "选择保存位置": 1057,
    "选择待导出目录": 1058,
    "获取自定义字段查询错误！": 1059,
    "忙碌中，请您留言，稍后回复": 1060,
    "您可以留言，我们看到后会在第一时间进行回复，或者您可以联系其他的客服人员，我们将竭诚为您服务！": 1061,
    "【自动回复】忙碌中，请您留言，稍后回复。": 1062,
    "【自动回复】您可以留言，我们看到后会在第一时间进行回复，或者您可以联系其他的客服人员，我们将竭诚为您服务！": 1063,
    "获取at成员信息失败，{}": 1064,
    "您好！我是{}，您有什么问题可以直接发送给我，我们会在第一时间为您解答！": 1065,
    "仅支持发送文件大小20M以内的图片": 1066,
    "{}【讨论文件合集({}项)】{}": 1067,
    "{}[图片]": 1068,
    "{}[文件]{}": 1069,
    "{}[群公告]": 1070,
    "置顶": 1071,
    "取消置顶": 1072,
    "移除会话": 1073,
    "消息免打扰": 1074,
    "允许消息通知": 1075,
    "草稿": 1076,
    "【讨论文件合集({}项)】": 1077,
    "有人@我": 1078,
    "日志消息": 1079,
    "[该消息类型本版本暂不支持查看(如需了解消息内容，请直接联系发送人)]": 1080,
    "条消息": 1081,
    "个文件": 1082,
    "条群公告": 1083,
    "该会话不存在": 1084,
    "您已离开该群聊，请联系相关人员进行添加！": 1085,
    "{}撤回了一{}": 1086,
    "请输入日志标题": 1087,
    "请输入日志内容": 1088,
    "发出人": 1089,
    "提交时间": 1090,
    "请输入日志评论内容": 1091,
    "点击选择日志评论人": 1092,
    "点击选择日志接收人": 1093,
    "搜索关联客户": 1094,
    "这个功能没什么用": 1095,
    "它分散了注意力": 1096,
    "不易理解上手难": 1097,
    "无法解决我的使用需求": 1098,
    "普通粘贴": 1099,
    "返回": 1100,
    "清空回收站": 1101,
    "您所在组织[{}]智慧云空间不足，请清理项目文档回收站或联系组织管理员进行扩容": 1102,
    "刚刚": 1103,
    "分钟前": 1104,
    "MM月DD日 HH:mm": 1105,
    "YYYY年MM月DD日 HH:mm": 1106,
    "所有人": 1107,
    "清空": 1108,
    "发送文件到": 1109,
    "拖拽编辑": 1110,
    "拖拽文件到此处进行上传": 1111,
    "当前应用不可用，请联系管理员": 1112,
    "没有匹配的小程序信息": 1113,
    "回复": 1114,
    "加急": 1115,
    "打开文件": 1116,
    "撤回": 1117,
    "该合并文件已超过600MB，请前往PC端下载": 1118,
    "历史版本V{}": 1119,
    "当前版本V{}": 1120,
    "群公告图片": 1121,
    "[有人@你]": 1122,
    "[@所有人]": 1123,
    "{}条新消息": 1124,
    "999+条新消息": 1125,
    "已超过可撤回时效": 1126,
    "已保存任务": 1127,
    "是否发消息通知执行人和抄送人?": 1128,
    "通知": 1129,
    "不用通知": 1130,
    "通知成功": 1131,
    "无法删除他人添加的执行人，请联系任务创建者操作": 1132,
    "(重复号码)": 1133,
    "请填写手机号": 1134,
    "(格式错误)": 1135,
    "删除任务": 1136,
    "关闭任务": 1137,
    "已开启拖拽排序功能": 1138,
    "已关闭拖拽排序功能": 1139,
    "确定要删除任务{}？": 1140,
    "确定要关闭任务{}": 1141,
    "确定要打开任务{}": 1142,
    "人未读": 1143,
    "全部已读": 1144,
    "正在努力加载中，请稍候…": 1145,
    "正在解锁并上传新版本，请稍候…": 1146,
    "查看成员": 1147,
    "下级": 1148,
    "创建普通群": 1149,
    "添加成员": 1150,
    "邀请成员": 1151,
    "条": 1152,
    "数据安全预警": 1153,
    "请登录CRM查看预警详情": 1154,
    "触发次数": 1155,
    "查看人员清单": 1156,
    "项目简报统计": 1157,
    "统计范围:所有项目(含可访问数据源)、按天提醒、昨天数据": 1158,
    "文件：": 1159,
    "次数：": 1160,
    "文件夹：": 1161,
    "应用时间:": 1162,
    "转发消息": 1163,
    "发送文件": 1164,
    "添加附件": 1165,
    "本地上传": 1166,
    "项目文档选择": 1167,
    "底稿选择": 1168,
    "请先选择项目后再添加附件": 1169,
    "当前审批未关联项目，因此无法选择底稿和项目文档文件": 1170,
    "当前未关联项目，因此无法选择底稿和项目文档文件": 1171,
    "请先选择所属项目": 1172,
    "选择浏览器": 1173,
    "本地浏览器": 1174,
    "扩展功能现支持Chrome浏览器、火狐浏览器、360极速模式浏览器、Safari浏览器、QQ极速模式浏览器、Microsoft Edge": 1175,
    "暂无可用浏览器": 1176,
    "现支持Chrome浏览器、火狐浏览器、360极速模式浏览器、Safari浏览器、QQ极速模式浏览器、Microsoft Edge": 1177,
    "Chrome浏览器": 1178,
    "火狐浏览器": 1179,
    "360极速模式浏览器": 1180,
    "QQ极速模式浏览器": 1181,
    "Safari浏览器": 1182,
    "开始日期": 1183,
    "结束日期": 1184,
    "版本号": 1185,
    "生成人": 1186,
    "点击查看在线编辑临时文件": 1187,
    "日期": 1188,
    "对 比": 1189,
    "文件版本": 1190,
    "还原后，当前文件「V{}」版本会保留在「文件版本」中同时会生成新的版本内容。确定要将文件还原为V{}版本内容吗？": 1191,
    "确定要还原版本内容吗？": 1192,
    "请选择两个版本进行对比": 1193,
    "文件已锁定，您不可以进行该操作": 1194,
    "还原成功": 1195,
    "归档文件不可进行此操作": 1196,
    "文件已锁定，不允许回退版本": 1197,
    "文件已锁定，不允许还原版本": 1198,
    "审批通过/审批中/修订审批中不允许还原版本": 1199,
    "回到应用中心": 1200,
    "中的搜索结果": 1201,
    "清空检索条件": 1202,
    "刷新": 1203,
    "更多目录": 1204,
    "已选中{}项": 1205,
    "请选择": 1206,
    "序号": 1207,
    "请选择项目": 1208,
    "搜索行业代码/行业分类名称": 1209,
    "搜索": 1210,
    "全选": 1211,
    "暂无数据": 1212,
    "重置": 1213,
    "重新加载": 1214,
    "正在加载中...": 1215,
    "数据获取失败，请重新加载！": 1216,
    "网络连接发生问题，请检查您的网络设置！": 1217,
    "多人在线编辑正在维护，暂不支持编辑模式切换，请双击文件使用单人本地编辑文件": 1218,
    "多人在线编辑正在维护，暂不支持编辑模式切换，请下载文件后在本地编辑文件": 1219,
    "图标": 1220,
    "多个文件": 1221,
    "多个文件夹": 1222,
    "多个": 1223,
    "个": 1224,
    "文件属性": 1225,
    "文件夹属性": 1226,
    "名称": 1227,
    "创建者": 1228,
    "包含": 1229,
    "正在计算...": 1230,
    "计算失败": 1231,
    "未选择行业分类，请先选择行业分类": 1232,
    "因多人在线编辑维护更新，编辑模式暂时不可切换，请使用单人本地编辑": 1233,
    "因多人在线编辑维护更新，编辑模式暂时不可切换，请下载文件使用本地office编辑完成后再上传文件": 1234,
    "网络异常，请检查当前设备的网络设置": 1235,
    "检测到当前账户": 1236,
    "未进行实名认证": 1237,
    "根据国家网络安全要求，账号需要“绑定手机号”实名认证后才能继续使用智慧云。可点击「实名认证」进行绑定。": 1238,
    "给您带来的不便，敬请谅解。": 1239,
    "实名认证": 1240,
    "我已认证": 1241,
    "切换组织": 1242,
    "请选择您想切换的组织": 1243,
    "加入新组织": 1244,
    "如果你的组织已在使用荣大智慧云，可通过组织ID查找加入，与成员一起沟通协作。": 1245,
    "创建新组织": 1246,
    "新组织创建后，你将成为管理员，可添加成员、管理组织架构，全面使用荣大智慧云的团队协作功能。": 1247,
    "加入或创建组织": 1248,
    "找到属于你的组织，和成员们一起协作办公": 1249,
    "安全校验未通过": 1250,
    "您好,由于您进入的{}": 1251,
    "设置了安全验证,您的IP地址未在组织要求的范围内,请尝试联系组织管理员处理或更换对应符合要求的网络后重试": 1252,
    "搜索组织名称": 1253,
    "组织不存在,无法进行操作": 1254,
    "项目编码：": 1255,
    "请选择项目编码": 1256,
    "发起人所属部门": 1257,
    "选择日期": 1258,
    "上传附件": 1259,
    "审批环节": 1260,
    "请填完必填项，会默认展示审批流程图。": 1261,
    "发起人": 1262,
    "审批人": 1263,
    "审批方式:": 1264,
    "注：审批流程涉及项目角色，需要选择项目后显示审批人。": 1265,
    "抄送方式:审批通过后通知": 1266,
    "添加抄送人": 1267,
    "注：审批流程涉及项目角色，需要选择项目后显示抄送人。": 1268,
    "是否设置提醒": 1269,
    "审批提醒": 1270,
    "接收人员": 1271,
    "提醒内容": 1272,
    "文件借阅": 1273,
    "借阅方式": 1274,
    "电子借阅": 1275,
    "纸质借阅": 1276,
    "借阅时间": 1277,
    "请选择借阅时间": 1278,
    "小时": 1279,
    "最多输入200字": 1280,
    "请选择部门": 1281,
    "审批方式": 1282,
    "抄送方式：审批通过后通知": 1283,
    "提 交": 1284,
    "底稿归档": 1285,
    "归档阶段": 1286,
    "审批环节:": 1287,
    "请输入申请内容，最多输入{}字": 1288,
    "提交": 1289,
    "IPO审核": 1290,
    "债务审核": 1291,
    "新三板审核": 1292,
    "归档表单": 1293,
    "你已经借阅当前文件": 1294,
    "底稿已被借阅": 1295,
    "请选择发起人所属部门": 1296,
    "项目归档成功后不可恢复，请谨慎操作是否确认提交归档申请？": 1297,
    "请选择您要借阅的时间": 1298,
    "请选择您要借阅的文件": 1299,
    "从借阅成功起，借阅时限为{}\"{}\"{}小时超过借阅时限后，借阅文件{}自动失效，无法查看{}是否确定借阅？": 1300,
    "确认关闭？": 1301,
    "本页面不可发起新建项目审批！": 1302,
    "无查看项目文档的权限": 1303,
    "项目所属业务类型与流程图所属业务类型不匹配": 1304,
    "提醒您尽快审批{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}": 1305,
    "提醒您尽快审批关于{}项目的{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}": 1306,
    "{}项目的": 1307,
    "提醒您尽快审批关于{}{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}": 1308,
    "接收人不能为空": 1309,
    "请填写提醒模版": 1310,
    "{}的邮箱发送失败；": 1311,
    "{}的短信发送失败；": 1312,
    "请在个人信息中完善！其余均发送成功": 1313,
    "请把表单填写完整": 1314,
    "有文件正在上传，请稍后操作": 1315,
    "请添加待审文件": 1316,
    "是否载入上次保存的草稿?": 1317,
    "确定要撤销申请吗, 是否继续?": 1318,
    "申请成功!": 1319,
    "已取消申请": 1320,
    "语言设置": 1321,
    "导航设置": 1322,
    "点击「右键」可以打开独立窗口": 1323,
    "点击进行自定义导航设置": 1324,
    "支持左右拖拽": 1325,
    "收起": 1326,
    "展开": 1327,
    "帮助": 1328,
    "隐藏应用名称": 1329,
    "已设为首页打开": 1330,
    "操作成功": 1331,
    "当前组织未填写股票代码，请前往组织信息中填写": 1332,
    "导航栏设置": 1333,
    "可以对导航栏入口进行排序和隐藏/显示设置": 1334,
    "取消首页打开": 1335,
    "创建一个组织": 1336,
    "在使用智慧云全部功能前，请先创建一个组织": 1337,
    "新组织": 1338,
    "创建": 1339,
    "新组织创建后，你将成员管理员，可添加成员、管理组织架构， 全面使用荣大智慧云的团队协作功能。": 1340,
    "加入项目": 1341,
    "当前": 1342,
    "收藏": 1343,
    "搜索项目": 1344,
    "编辑头像": 1345,
    "图片预览": 1346,
    "保存": 1347,
    "截图请大于": 1348,
    "编辑群信息": 1349,
    "群名称": 1350,
    "请输入群名称（字数限制{}字）": 1351,
    "群头像": 1352,
    "还原默认头像": 1353,
    "输入头像文字": 1354,
    "选择头像底色": 1355,
    "如果仅选择颜色，将使用该颜色的默认头像": 1356,
    "人员管理": 1357,
    "角色权限": 1358,
    "组织架构": 1359,
    "底稿管理": 1360,
    "目录管理": 1361,
    "流程引擎管理": 1362,
    "流程引擎": 1363,
    "系统配置": 1364,
    "业务类型配置": 1365,
    "任务配置": 1366,
    "业务规则配置": 1367,
    "借阅时间配置": 1368,
    "时间变量配置": 1369,
    "表单字段管理": 1370,
    "审批类型配置": 1371,
    "日志模板配置": 1372,
    "项目角色配置": 1373,
    "安全规则配置": 1374,
    "系统日志": 1375,
    "选择": 1376,
    "查询": 1377,
    "发起": 1378,
    "该流程不可用！": 1379,
    "不可发起新建项目审批！": 1380,
    "请选择项目！": 1381,
    "发起审批": 1382,
    "搜索业务类型": 1383,
    "共{}个结果,第{}个": 1384,
    "当前业务类型": 1385,
    "未搜索到结果": 1386,
    "无数据，请输入其他关键字后重试": 1387,
    "请输入想要搜索的业务类型关键字后点击搜索": 1388,
    "新增联系人": 1389,
    "姓名": 1390,
    "联系方式": 1391,
    "所属公司": 1392,
    "下一步": 1393,
    "请选择所属公司": 1394,
    "暂不支持输入特殊字符，请重新输入": 1395,
    "性别": 1396,
    "学历": 1397,
    "邮箱": 1398,
    "添加部门/职务": 1399,
    "是否公开": 1400,
    "非公开联系人仅支持在通讯录中进行查看，不支持被关联到项目": 1401,
    "是": 1402,
    "否": 1403,
    "上一步": 1404,
    "男": 1405,
    "女": 1406,
    "新增成功": 1407,
    "在「{}」下新增联系方式": 1408,
    "确定要继续添加联系方式吗？": 1409,
    "联系方式为「{}」的联系人已存在": 1410,
    "联系方式为「{}」的联系人已存在，其信息未公开，无法查看，请联系通讯录管理员": 1411,
    "创建联系人": 1412,
    "将在企业【{}】下新增联系人【{}】，是否将此联系人关联至当前项目【{}】？": 1413,
    "仅创建": 1414,
    "创建并关联至项目": 1415,
    "查询到企业「{}」下存在同名联系人，请确认其是否已存在但未维护对应联系方式": 1416,
    "如果确认要新增联系人，请点击【跳过并到下一步】继续创建": 1417,
    "在职": 1418,
    "已离职": 1419,
    "添加联系方式": 1420,
    "跳过并到下一步": 1421,
    "链接发送到我手机": 1422,
    "预警人员清单": 1423,
    "请输入人员名称": 1424,
    "选择审批类型": 1425,
    "选择类型": 1426,
    "输入关键字进行搜索": 1427,
    "已选择类型": 1428,
    "暂无选中项": 1429,
    "当前该业务类型不可选": 1430,
    "已选择": 1431,
    "关联": 1432,
    "索引列表": 1433,
    "文件索引": 1434,
    "选中文件": 1435,
    "索引路径": 1436,
    "操作人": 1437,
    "关联任务": 1438,
    "暂无对应权限": 1439,
    "请联系管理员": 1440,
    "确认引用": 1441,
    "引用后，当前目录将会清空！": 1442,
    "我已确认": 1443,
    "确认": 1444,
    "跳过": 1445,
    "选择任务模板": 1446,
    "该业务类型没有匹配的任务模板（请联系管理员为该业务类型配置任务模板）": 1447,
    "未选择任务模板，请选中对应模板后重试": 1448,
    "该业务类型没有匹配的目录": 1449,
    "（请联系管理员为该业务类型配置目录）": 1450,
    "未选择目录模板，请选中对应模板后重试": 1451,
    "确定要引用该底稿目录吗？": 1452,
    "引用后，当前目录将会被覆盖，确定要引用吗？": 1453,
    "加载失败": 1454,
    "请选择内容": 1455,
    "选择中介机构": 1456,
    "已选机构": 1457,
    "选择团队成员": 1458,
    "团队成员": 1459,
    "已选成员": 1460,
    "关联角色不能为空！": 1461,
    "选择业务类型": 1462,
    "跳 过": 1463,
    "当前项目阶段为空，不可选择": 1464,
    "清空选项": 1465,
    "请选择客户": 1466,
    "数据中心": 1467,
    "使用": 1468,
    "该类型暂不支持编辑": 1469,
    "表情": 1470,
    "自然": 1471,
    "物品": 1472,
    "地点": 1473,
    "符号": 1474,
    "当前支持核查文件的数量的最大值为{}个！": 1475,
    "单文件大小要小于等于{}M": 1476,
    "当前只支持对DOC、DOCX、XLS、XLSX、PDF（必须是可编辑版转换的）的文件进行核查！": 1477,
    "文件参数格式缺失！": 1478,
    "分享文件": 1479,
    "您可以将链接分享给您的朋友们": 1480,
    "复制链接": 1481,
    "取消外链": 1482,
    "复制成功": 1483,
    "复制失败": 1484,
    "外链取消成功": 1485,
    "外链取消失败": 1486,
    "文件分享": 1487,
    "移除": 1488,
    "重置链接": 1489,
    "通过二维码分享": 1490,
    "链接复制成功": 1491,
    "链接复制失败": 1492,
    "二维码复制成功": 1493,
    "二维码复制失败": 1494,
    "备注": 1495,
    "当前已选中": 1496,
    "新增备注": 1497,
    "请输入备注": 1498,
    "最多输入{}字": 1499,
    "请新增备注内容": 1500,
    "新增备注成功": 1501,
    "创建模板分类": 1502,
    "创 建": 1503,
    "上传到模板提示": 1504,
    "选择目录": 1505,
    "请选择目录": 1506,
    "编辑会议": 1507,
    "选择人员": 1508,
    "请输入会议主题": 1509,
    "请选择会议类型": 1510,
    "请输入会议地点": 1511,
    "起止时间": 1512,
    "会议时间": 1513,
    "会议开始时间": 1514,
    "会议结束时间": 1515,
    "提醒": 1516,
    "请输入会议内容": 1517,
    "会议开始时间不能为空": 1518,
    "会议结束时间不能为空": 1519,
    "开始时间不能小于当前时间": 1520,
    "不能同时为参会和列席人员": 1521,
    "会议主题不能为空": 1522,
    "会议地点不能为空": 1523,
    "开始时间不能大于结束时间": 1524,
    "开始时间不能等于结束时间": 1525,
    "请选择提醒方式": 1526,
    "暂无备注信息": 1527,
    "备注内容": 1528,
    "备注时间": 1529,
    "发送": 1530,
    "请输入备注内容": 1531,
    "文件关联": 1532,
    "所有人可见备注，对文件夹右键可导出核查报告（所有文件的备注）": 1533,
    "隐藏": 1534,
    "确认永久隐藏该功能吗？可在更多中勾选 \" 核查备注 \" 重新开启。": 1535,
    "确定删除备注吗？": 1536,
    "删除备注成功": 1537,
    "文件上传": 1538,
    "进度条": 1539,
    "上传速度": 1540,
    "添加文件": 1541,
    "开始上传": 1542,
    "最大允许上传{}条数据": 1543,
    "初始化中": 1544,
    "允许上传的文件类型为": 1545,
    "上传中": 1546,
    "删除成功": 1547,
    "保存新版本失败，请联系客服处理。": 1548,
    "客服电话": 1549,
    "我的客户-企业客户-客户文档": 1550,
    "我的客户-自然人客户-客户文档": 1551,
    "我的客户-中介机构-客户文档": 1552,
    "投票决策": 1553,
    "投票意见": 1554,
    "请输入投票意见": 1555,
    "同意": 1556,
    "确定要执行投票吗？": 1557,
    "投票决策仅可执行一次，确定要继续操作吗？": 1558,
    "已取消投票": 1559,
    "投票意见不能为空": 1560,
    "请选择投票类型": 1561,
    "选择开始日期时间": 1562,
    "选择结束日期时间": 1563,
    "该投票需要角色": 1564,
    "不少于": 1565,
    "投票名称不能为空": 1566,
    "投票类型不能为空": 1567,
    "投票人不能为空": 1568,
    "请选择开始时间": 1569,
    "请选择结束时间": 1570,
    "结束时间需大于当前时间1小时": 1571,
    "投票名称内容不能为空": 1572,
    "投票结果": 1573,
    "项目简称": 1574,
    "所属部门:": 1575,
    "项目描述": 1576,
    "相关会议": 1577,
    "表决结果": 1578,
    "（已选中": 1579,
    "项，共": 1580,
    "项）": 1581,
    "该文件已删除": 1582,
    "加载中": 1583,
    "】邀请您加入【": 1584,
    "】项目": 1585,
    "所属组织": 1586,
    "忽略": 1587,
    "项目文件": 1588,
    "联系人{}群组": 1589,
    "选择对象": 1590,
    "esc退出搜索": 1591,
    "交接详情": 1592,
    "指派交接": 1593,
    "交接人 【": 1594,
    "暂不处理": 1595,
    "指派选中项": 1596,
    "请选择移交人": 1597,
    "你是否满意本次版本(v1.6.0)更新？": 1598,
    "需要再用用": 1599,
    "有进步": 1600,
    "很赞": 1601,
    "产品经理：范恺": 1602,
    "产品建议、吐槽、唠嗑、养猫...": 1603,
    "欢迎扫描左侧二维码": 1604,
    "交个朋友": 1605,
    "这里是标题": 1606,
    "高级检索": 1607,
    "未填写": 1608,
    "高级筛选": 1609,
    "清空筛选条件": 1610,
    "暂未查询到与": 1611,
    "相符的内容或信息": 1612,
    "暂未查询到与之相符的内容或信息": 1613,
    "包含高级检索条件": 1614,
    "请检查输入的关键词是否有误": 1615,
    "或": 1616,
    "点击此处": 1617,
    "使用全文检索查找相关内容": 1618,
    "已锁定、有索引的、有备注的、有审批记录的、无索引的、待审批、审批中、节点审批通过、审批通过、驳回未修改、驳回已修改、修订中、修订审批中、有设置提醒的、已归档": 1619,
    "无文件、有文件": 1620,
    "{} 至 {}": 1621,
    "最小化": 1622,
    "最大化": 1623,
    "可正常发消息的群数量/可使用的群上限": 1624,
    "可正常发消息的群组(": 1625,
    "暂无群组": 1626,
    "查看已选列表": 1627,
    "当前已选数量": 1628,
    "替换": 1629,
    "不可发消息的群数量": 1630,
    "可替换群组(": 1631,
    "暂无可替换群组": 1632,
    "当前可选数量": 1633,
    "当前无选中的群组": 1634,
    "置换成功": 1635,
    "置换失败": 1636,
    "返回前台": 1637,
    "切换语言": 1638,
    "偏好设置": 1639,
    "版本说明": 1640,
    "使用帮助": 1641,
    "下载手机版": 1642,
    "信披搜索、数据中心一键直达": 1643,
    "二郎神": 1644,
    "咨询服务": 1645,
    "有新版本可更新": 1646,
    "文件处理列表": 1647,
    "下载客户端": 1648,
    "手机端下载": 1649,
    "有更新可用，刷新即可": 1650,
    "传输列表": 1651,
    "搜索（{}）": 1652,
    "检测到新的版本更新，点击「立即更新」后进行体验": 1653,
    "版本更新": 1654,
    "立即更新": 1655,
    "使用帮助手册": 1656,
    "确认退出登录吗": 1657,
    "退出失败!": 1658,
    "传输列表中，有文件进度卡在0或100不继续进行，初步判断是由于域名解析失败导致的，建议使用DNS优先进行解决。": 1659,
    "后续出现此问题不再提示": 1660,
    "前去启用": 1661,
    "稍后可在系统设置中启用DNS优选功能。": 1662,
    "若您使用DNS优选功能后，仍多次捕获到域名无法解析，您可以联系售后询问，售后电话：": 1663,
    "清除选中记录": 1664,
    "全部取消": 1665,
    "待处理文件": 1666,
    "注：请您核对上传失败版本与当前版本内容，如要上传新版本": 1667,
    "请备份后手动上传": 1668,
    "，点击定位可跳转到文件所在位置。": 1669,
    "组织名称": 1670,
    "版本进行": 1671,
    "手动解锁": 1672,
    "备份": 1673,
    "粘贴文件": 1674,
    "暂无任务": 1675,
    "文件数量": 1676,
    "进度": 1677,
    "锁定文件": 1678,
    "展示最近一次进行批量解锁时，所选文件范围内的锁定文件": 1679,
    "文件处理": 1680,
    "粘贴任务正在进行，确定要取消操作吗？": 1681,
    "成功": 1682,
    "正在准备复制": 1683,
    "正在复制": 1684,
    "暂不支持跳转客户文档": 1685,
    "清除记录成功": 1686,
    "hover 激活": 1687,
    "呕心沥血难保错误少 智能核查荣大新法宝": 1688,
    "分享的图片": 1689,
    "当前图片序号：": 1690,
    "该图片已被撤回": 1691,
    "实际大小": 1692,
    "缩小": 1693,
    "旋转": 1694,
    "{}分享的图片": 1695,
    "复制成功！": 1696,
    "复制失败，请联系管理员进行反馈！": 1697,
    "链接邀请成员": 1698,
    "组织链接": 1699,
    "分享链接，快速邀请成员加入组织。": 1700,
    "失效时间": 1701,
    "复制链接邀请": 1702,
    "“{}”邀请您加入“{}”,点击链接立即申请加入吧！用荣大智慧云开启高效协作模式。": 1703,
    "邀请链接复制成功": 1704,
    "邀请链接复制失败": 1705,
    "邀请组织成员一起协作": 1706,
    "当前组织可用人数": 1707,
    "人": 1708,
    "可再邀请": 1709,
    "增加可用人数": 1710,
    "邀请组织成员": 1711,
    "邀请其他组织成员": 1712,
    "链接邀请": 1713,
    "邀请成功": 1714,
    "请输入成员手机号或邮箱": 1715,
    "继续添加": 1716,
    "发送邀请": 1717,
    "手机号/邮箱格式错误": 1718,
    "已邀请加入组织": 1719,
    "加入组织": 1720,
    "通过组织ID查找加入。暂无组织，点击": 1721,
    "创建组织": 1722,
    "组织ID": 1723,
    "请输入组织ID": 1724,
    "加入": 1725,
    "已提交申请": 1726,
    "请耐心等待管理员审核": 1727,
    "组织类型": 1728,
    "请输入{}ID": 1729,
    "搜索内容为空": 1730,
    "申请加入": 1731,
    "组织": 1732,
    "您可以联系组织管理者索取组织ID，申请加入对应的组织。也可以由组织成员通过您的验证邮箱或手机号邀请您加入组织。": 1733,
    "您可以联系项目负责人索取项目ID，申请加入对应的项目。也可以由项目负责人邀请您加入项目。": 1734,
    "申请加入产研项目组，项目编码:{}": 1735,
    "加入申请已发送": 1736,
    "申请加入成功": 1737,
    "拼命加载中": 1738,
    "已选": 1739,
    "邀请你加入「": 1740,
    "即刻加入": 1741,
    "协作邀请": 1742,
    "加入团队一起高效协作办公，告别繁琐和沉重的重复工作": 1743,
    "链接不存在": 1744,
    "邀请链接不存在或已失效，请联系项目管理员重新发起邀请": 1745,
    "项目加入成功": 1746,
    "链接已失效，请联系邀请人重新发送邀请": 1747,
    "消息加急提醒": 1748,
    "1、群聊内发送含@人员的消息可加急提醒单聊消息均支持加急提醒": 1749,
    "2、提醒方式可选": 1750,
    "“仅应用内”": 1751,
    "“应用内+短信”": 1752,
    "的方式。": 1753,
    "由于部分文件编码格式特殊，如遇到不能正常播放时,请下载查看": 1754,
    "您的浏览器不支持video播放": 1755,
    "该{}已被撤回": 1756,
    "暂不提示": 1757,
    "永不提示": 1758,
    "在线服务": 1759,
    "群聊的备注名称仅自己可见": 1760,
    "组织的备注名称仅自己可见": 1761,
    "操作时间": 1762,
    "操作人员": 1763,
    "账号验证": 1764,
    "当前用户": 1765,
    "登录密码": 1766,
    "请输入密码": 1767,
    "选择移交人员": 1768,
    "点击选择移交人员": 1769,
    "移交组织": 1770,
    "删除组织": 1771,
    "请选择移交人员": 1772,
    "密码不能为空": 1773,
    "最多输入50字": 1774,
    "请选择组织类型": 1775,
    "股票代码": 1776,
    "请输入股票代码(最多输入6个数字)": 1777,
    "组织简介": 1778,
    "请输入组织简介(最多输入200字)": 1779,
    "使用官方提供的初始化数据模板": 1780,
    "注：数据包含系统角色及权限、项目角色及权限、底稿目录、业务类型（含项目阶段）、任务模板、时间变量": 1781,
    "组织名称不能为空": 1782,
    "组织类型不能为空": 1783,
    "请填写正确的股票代码": 1784,
    "组织简介的字数限制为200字": 1785,
    "修改股票代码后，已经上传的股东名册数据不可见，请慎重修改!": 1786,
    "修改成功": 1787,
    "组织创建成功": 1788,
    "现在，从新建一个项目开始全面使用智慧云吧跟着引导，轻松几步就搞定": 1789,
    "稍后新建": 1790,
    "开始体验前，请先创建一个组织吧": 1791,
    "您的角色（选填）": 1792,
    "请输入(选填)": 1793,
    "暂不创建": 1794,
    "建立一个敏捷项目组，开启文档、任务等核心功能": 1795,
    "暂不": 1796,
    "请选择业务类型": 1797,
    "新建项目已提交审批！": 1798,
    "项目创建成功": 1799,
    "恭喜你已成功开启文档、任务等智慧云的核心功能，现在开始体验吧": 1800,
    "立即体验": 1801,
    "系统消息图": 1802,
    "推广活动图": 1803,
    "支持格式{}，请上传正确格式图片": 1804,
    "删除组织后：": 1805,
    "组织内所有内容（项目、文档、部门、成员等）都将永久删除，此操作不可逆，请谨慎操作": 1806,
    "当前组织已经购买的人员和空间将同步失效": 1807,
    "可用人数": 1808,
    "可用空间": 1809,
    "到期时间": 1810,
    "确定删除": 1811,
    "试用版永久免费！使用更多人员和空间，请购买正式版！": 1812,
    "{}/{}人": 1813,
    "智慧云已用空间": 1814,
    "已超总空间限制": 1815,
    "项目已用空间(包含回收站)": 1816,
    "客户文档已用空间": 1817,
    "剩余空间": 1818,
    "项目已用空间": 1819,
    "搜索项目ID/项目名称": 1820,
    "正在清空回收站，请稍候；本次计算完成后才能进行下一次清空！": 1821,
    "正在清空": 1822,
    "排名": 1823,
    "已用总空间": 1824,
    "文档已用空间": 1825,
    "文档回收站已用空间": 1826,
    "购买": 1827,
    "获取数据失败，请稍后重试": 1828,
    "空间比例计算失败，请联系管理员": 1829,
    "你确定要清空所有项目的文档回收站吗？清空后文件将无法恢复": 1830,
    "操作失败，请稍后重试": 1831,
    "获取权限失败，请稍后重试": 1832,
    "项目文档-回收站": 1833,
    "组织信息": 1834,
    "没有找到相关结果": 1835,
    "备注名（仅个人可见）": 1836,
    "暂无": 1837,
    "付费信息": 1838,
    "试用版": 1839,
    "正式版": 1840,
    "试用版永久免费！如需添加更多人员和使用空间，请购买正式版。": 1841,
    "立即购买": 1842,
    "续费": 1843,
    "成员数量": 1844,
    "扩容": 1845,
    "成员数量已超限制，请扩容": 1846,
    "系统空间": 1847,
    "系统空间已超限制，请扩容": 1848,
    "更多内容": 1849,
    "归属者": 1850,
    "退出组织": 1851,
    "删除组织后，组织内所有项目、部门、成员、文档等内容将永久删除且不可恢复，请谨慎操作": 1852,
    "一旦你退出了组织，将无法再看到该组织内的所有信息及文档，请谨慎对待": 1853,
    "确定移交组织吗？": 1854,
    "移交组织后你将不再是该组织的所属者, 仅保留管理员权限, 确定要继续移交组织吗?": 1855,
    "交接工作": 1856,
    "退出组织后，你在该组织下的所有项目将会转交给对方，由你上锁的文件将会自动解锁": 1857,
    "选择交接人员": 1858,
    "点击选择交接人员": 1859,
    "交接人不能为空": 1860,
    "退出成功": 1861,
    "已发送通知给用户": 1862,
    ", 请提醒对方查收": 1863,
    "确定退出": 1864,
    "交接人不能选本人": 1865,
    "移交后你将不再是该组织的所属者，但保留管理员权限，是否继续移交？": 1866,
    "移 交": 1867,
    "移交成功": 1868,
    "文件目录": 1869,
    "操作对象": 1870,
    "通过文档下载文件/文件夹": 1871,
    "点击外链分享": 1872,
    "通过外链分享下载文件/文件夹": 1873,
    "删除文件/文件夹": 1874,
    "修改文件": 1875,
    "新增文件/文件夹": 1876,
    "推送设置": 1877,
    "是否推送文件统计": 1878,
    "推送": 1879,
    "不推送": 1880,
    "在全部组织中不进行推送": 1881,
    "勾选后您将不接收所有组织的项目简报统计信息": 1882,
    "每天{}推送昨日文件相关数据": 1883,
    "上午10:00": 1884,
    "文件编辑模式设置": 1885,
    "选择开启以下文件类型，所有成员可对不同类型格式的文件进行多人在线编辑": 1886,
    "Word 类文件": 1887,
    "多人编辑开启后将使用WPS编辑器进行文件编辑，可能会与通过MS office编辑器进行编辑的文件产生兼容影响，请知悉！": 1888,
    "开启后，可对该类型文件进行多人在线编辑(文件格式包含：doc | docx | dot | dotx | wps | wpt | docm)": 1889,
    "Excel 类文件": 1890,
    "开启后，可对该类型文件进行多人在线编辑(文件格式包含：xls | xlsx | xlsm | xlt | xltx |et)": 1891,
    "PPT 类文件": 1892,
    "开启后，可对该类型文件进行多人在线编辑(文件格式包含：ppt | pptx | pptm | pps | ppsx |ppsm | potx | dpt | dps)": 1893,
    "PDF 类文件": 1894,
    "开启后，可对该类型文件进行多人在线编辑": 1895,
    "多人编辑开启后将使用WPS编辑器进行文件编辑，可能会与通过MS office编辑器进行编辑的文件产生兼容影响。如果编辑文件时对格式要求比较敏感，为了减少因兼容问题导致格式错乱的风险，建议保持使用本地编辑模式；确定继续开启多人编辑模式吗？": 1896,
    "确定开启「多人编辑」模式吗？": 1897,
    "自定义功能栏": 1898,
    "请输入任务文件夹名称": 1899,
    "完成": 1900,
    "完成并转发": 1901,
    "分享任务": 1902,
    "分享成功": 1903,
    "请填写完整": 1904,
    "请选择标签名称": 1905,
    "无标签": 1906,
    "项目名备注（仅自己可见）": 1907,
    "请输入备注名称（最多20字）": 1908,
    "取 消": 1909,
    "确 定": 1910,
    "请选择文件": 1911,
    "该文件正在审批中，不能选择": 1912,
    "锁定中的文件不能再次发起审批，请重新选择": 1913,
    "请输入文件夹名称": 1914,
    "未检索到相关内容": 1915,
    "请选择要保存的路径": 1916,
    "操作失败，图片大小不超过20M": 1917,
    "富文本编辑器图片上传": 1918,
    "启用": 1919,
    "禁用": 1920,
    "新建空白日志": 1921,
    "复用已有日志": 1922,
    "模板已启用": 1923,
    "模板已禁用": 1924,
    "你确定要删除该日志模板吗?": 1925,
    "该文件格式不支持在线编辑": 1926,
    "多人在线": 1927,
    "单人本地": 1928,
    "取消关联": 1929,
    "共{}项": 1930,
    "请输入昵称": 1931,
    "正在解锁并保存文件": 1932,
    "该文件夹已被删除，即将返回首层文件夹": 1933,
    "继续提交": 1934,
    "残忍离开": 1935,
    "不支持该类型文件上传，请重新选择": 1936,
    "支持格式{}，请上传正确格式头像": 1937,
    "头像大小不能超过10MB": 1938,
    "检测到本次上传有{}个重名对象 (文件夹/文件)": 1939,
    "更新版本": 1940,
    "为本次所有重名对象执行此操作": 1941,
    "文件重名": 1942,
    "文件上传 (": 1943,
    "重试": 1944,
    "找不到文件路径": 1945,
    "等待上传": 1946,
    "正在上传": 1947,
    "上传新版本每次只能上传一个文件": 1948,
    "无更新版本权限": 1949,
    "该文件夹下无文件，请重新选择": 1950,
    "无后缀名文件": 1951,
    "文件名称不能为空": 1952,
    "该文件超出100G限制": 1953,
    "普通文件": 1954,
    "荣大XB": 1955,
    "北交所XB": 1956,
    "文件上传成功": 1957,
    "文件上传失败，请检查网络，或选择重新上传": 1958,
    "部分文件上传失败，请检查网络，或选择重新上传": 1959,
    "当前项目进行阶段": 1960,
    "文件保存路径": 1961,
    "选择上传阶段": 1962,
    "选择粘贴阶段": 1963,
    "上传阶段": 1964,
    "粘贴阶段": 1965,
    "项目文档 / {} / 底稿上传": 1966,
    "上传文件到「": 1967,
    "上传文件到当前目录下": 1968,
    "客户文档暂不支持文件夹上传，将自动过滤": 1969,
    "搜索结果页不允许上传": 1970,
    "左侧暂无目录，无法进行上传操作": 1971,
    "很抱歉，您访问的浏览器无法使用“文件夹上传”功能！": 1972,
    "1、为了获得更好的使用体验，您可以下载最新版本的": 1973,
    "并设置成默认浏览器": 1974,
    "2、您也可以下载使用最新的荣大智慧云客户端": 1975,
    "条)": 1976,
    "标准化": 1977,
    "预 览": 1978,
    "只 读": 1979,
    "下 载": 1980,
    "当文件编辑后“": 1981,
    "大小超过20MB将无法保存成功": 1982,
    "”，建议": 1983,
    "以上的文件通过“": 1984,
    "”方式进行编辑；": 1985,
    "当文件通过“": 1986,
    "”方式时，需要注意“": 1987,
    "编辑后的": 1988,
    "文件大小不超过20MB”。": 1989,
    "注：上述问题正在努力解决中，请耐心等待…": 1990,
    "关 闭": 1991,
    "个,": 1992,
    "已驳回": 1993,
    "审批意见": 1994,
    "暂无审批意见": 1995,
    "【版本:": 1996,
    "取消回复": 1997,
    "发布": 1998,
    "条回复": 1999,
    "请输入{}审批意见，最多输入1000字": 2000,
    "审批结果": 2001,
    "通过": 2002,
    "消息通知": 2003,
    "通过站内信通知发起人查看": 2004,
    "审批回复详情": 2005,
    "共有": 2006,
    "请输入意见内容": 2007,
    "请勾选审批结果": 2008,
    "审批记录": 2009,
    "提交人": 2010,
    "审批状态": 2011,
    "未审批": 2012,
    "提审": 2013,
    "查看审批": 2014,
    "列表": 2015,
    "审批附件": 2016,
    "审批信息": 2017,
    "级审批:": 2018,
    "审批时间": 2019,
    "转交时间": 2020,
    "转交理由": 2021,
    "我的审批-我发起的-审批记录-查看-{}审批-{}审批意见页": 2022,
    "请选择要下载的数据": 2023,
    "{}-审批附件.zip": 2024,
    "批量编辑角色": 2025,
    "输入关键字搜索": 2026,
    "取消关联审批": 2027,
    "此审批流程要求您要有关联的审批": 2028,
    "提交人员": 2029,
    "是否取消该关联": 2030,
    "勾选后以下人员必须将日程抄送给我": 2031,
    "输入关键字进行过滤": 2032,
    "已选人员": 2033,
    "注：全选后新加入部门的人员自动抄送": 2034,
    "请输入人员": 2035,
    "暂未选择人员": 2036,
    "修改日程": 2037,
    "请输入日程名称": 2038,
    "请选择人员": 2039,
    "全天": 2040,
    "默认通过站内信通知发送给对方，点击x删除": 2041,
    "日程名称内容不能为空": 2042,
    "所属项目不能为空": 2043,
    "人员不能为空": 2044,
    "开始日期不能为空": 2045,
    "结束日期不能为空": 2046,
    "结束日期不能大于开始日期": 2047,
    "日期重复方式不能为空": 2048,
    "日程内容不能为空": 2049,
    "机构联系人": 2050,
    "系统角色": 2051,
    "默认的人员不能删除": 2052,
    "默认抄送人员不能删除": 2053,
    "可选人员": 2054,
    "请输入角色": 2055,
    "手机号": 2056,
    "职位": 2057,
    "编辑标签": 2058,
    "标签": 2059,
    "最多还能添加{}个": 2060,
    "按enter键进行分割": 2061,
    "最近使用的标签": 2062,
    "标签名不能相同": 2063,
    "标签最多添加10个": 2064,
    "标签名不能为空": 2065,
    "我的日程": 2066,
    "编 辑": 2067,
    "删 除": 2068,
    "新建日志": 2069,
    "请选择所属项目": 2070,
    "日志类型": 2071,
    "请选择日志类型": 2072,
    "确 认": 2073,
    "日报": 2074,
    "周报": 2075,
    "月报": 2076,
    "日志类型不能为空": 2077,
    "审批流程预览": 2078,
    "暂无附件": 2079,
    "上一步执行人": 2080,
    "指定用户": 2081,
    "指定角色": 2082,
    "前台": 2083,
    "后台": 2084,
    "部门主管": 2085,
    "发起人的": 2086,
    "级主管": 2087,
    "暂未选择审批人": 2088,
    "暂未匹配到对应的审批人": 2089,
    "暂未配置流程图": 2090,
    "已选目录": 2091,
    "请输入关键字（以空格区分）": 2092,
    "暂无相关聊天记录": 2093,
    "点击可定位到对应聊天记录": 2094,
    "昨天{}": 2095,
    "选择角色": 2096,
    "待选角色": 2097,
    "已选角色": 2098,
    "时间选择": 2099,
    "请输入操作人": 2100,
    "操作类型": 2101,
    "请选择操作类型": 2102,
    "事件": 2103,
    "导出": 2104,
    "增加目录": 2105,
    "删除目录": 2106,
    "重命名目录": 2107,
    "下载文件": 2108,
    "解锁文件": 2109,
    "重命名文件": 2110,
    "删除文件": 2111,
    "预览文件": 2112,
    "更新文件版本": 2113,
    "版本还原": 2114,
    "下载全局查看文件": 2115,
    "导出全局查看记录": 2116,
    "增加文件批注": 2117,
    "添加标签": 2118,
    "取消标签": 2119,
    "添加索引": 2120,
    "取消索引": 2121,
    "设为底稿": 2122,
    "增加目录批注": 2123,
    "关联审批": 2124,
    "关联审批（当前审批已关联审批）": 2125,
    "请选择状态": 2126,
    "提交人：": 2127,
    "请选择提交人": 2128,
    "待我审批": 2129,
    "我已审批": 2130,
    "全部（": 2131,
    "审批完成（": 2132,
    "审批中（": 2133,
    "当前审批人": 2134,
    "我发起的": 2135,
    "已撤销（": 2136,
    "抄送我的": 2137,
    "暂未选择角色": 2138,
    "待选类型": 2139,
    "已选类型": 2140,
    "暂未选择类型": 2141,
    "请输入关键字": 2142,
    "| 前台": 2143,
    "| 前台": 2144,
    "| 后台": 2145,
    "| 后台": 2146,
    "投票记录": 2147,
    "投票时间:": 2148,
    "未投票": 2149,
    "投票附件": 2150,
    "该附件被删除": 2151,
    "{}- 投票附件.zip": 2152,
    "我们正在全力搜索中，请点击": 2153,
    "刷新试试": 2154,
    "正在登录中......": 2155,
    "客户端下载": 2156,
    "关于我们": 2157,
    "高效": 2158,
    "专业": 2159,
    "协作": 2160,
    "管理": 2161,
    "登录": 2162,
    "北京荣大科技股份有限公司": 2163,
    "服务热线": 2164,
    "暂不支持IE浏览器10以下版本！请更新您的浏览器版本": 2165,
    "您已成功加入群聊": 2166,
    "新建第一个项目": 2167,
    "跟着引导，轻松几步搞定，开启智慧云文档、任务等核心功能，并邀请成员一起在线协作": 2168,
    "立即开始": 2169,
    "欢迎来到智慧云": 2170,
    "为了让智慧云能够更大限度的帮助你，在开始前，请帮助我们了解你": 2171,
    "选择你的机构属性": 2172,
    "进入项目": 2173,
    "查看新用户引导": 2174,
    "快速开始": 2175,
    "我们准备了「{}」常用的核心功能引导帮助你快速理解和使用智慧云！": 2176,
    "我要自行探索": 2177,
    "开始体验": 2178,
    "返回上一步": 2179,
    "数据列表": 2180,
    "请搜索版本号": 2181,
    "刷新列表": 2182,
    "新增数据": 2183,
    "链接地址": 2184,
    "说明": 2185,
    "暂无收藏项目": 2186,
    "删除后，会在联系人已关联的项目中同步进行移除": 2187,
    "公司信息": 2188,
    "离职": 2189,
    "职务：": 2190,
    "从业履历": 2191,
    "起始日期": 2192,
    "截止日期": 2193,
    "更新时间": 2194,
    "研究生": 2195,
    "请填写部门和职务": 2196,
    "编辑成功": 2197,
    "联系人详情": 2198,
    "基本信息": 2199,
    "项目经历": 2200,
    "确定要关闭页面吗？": 2201,
    "当前处于编辑状态，当前操作将不保存修改内容，确定要继续操作吗？": 2202,
    "确认要离开此页面吗？": 2203,
    "客户学历": 2204,
    "（非公开联系人仅支持在通讯录中进行查看，不支持被关联到项目）": 2205,
    "融资类型": 2206,
    "交易板块": 2207,
    "交易场所": 2208,
    "上市（挂牌）日期": 2209,
    "项目角色": 2210,
    "联系人姓名": 2211,
    "全部拒绝": 2212,
    "终止授权": 2213,
    "已授权": 2214,
    "未授权": 2215,
    "联系方式授权": 2216,
    "联系方式终止授权": 2217,
    "授权": 2218,
    "授权（{}）": 2219,
    "申请人": 2220,
    "应用项目": 2221,
    "待确认": 2222,
    "申请时间": 2223,
    "最后更新时间": 2224,
    "共": 2225,
    "客户信息": 2226,
    "统一社会信用代码": 2227,
    "企业类型": 2228,
    "法定代表人": 2229,
    "注册资本": 2230,
    "成立日期": 2231,
    "主营业务": 2232,
    "客户信息（选填）": 2233,
    "企业名称": 2234,
    "请选择企业": 2235,
    "法人代表": 2236,
    "此客户已关联，请勿重复操作！": 2237,
    "中介机构（选填）": 2238,
    "添加关联": 2239,
    "新增客户": 2240,
    "自动回显": 2241,
    "经营状态": 2242,
    "代表人职务": 2243,
    "企业地址": 2244,
    "企业标签": 2245,
    "请选择企业名称": 2246,
    "请选择客户类型": 2247,
    "当前已有内容，关闭将不予保存，确定要继续操作吗？": 2248,
    "选择企业": 2249,
    "仅支持输入中文关键词搜索": 2250,
    "与“{}”相匹配的企业": 2251,
    "没有找到相匹配的企业": 2252,
    "请输入正确的企业名称": 2253,
    "查询失败，请联系管理员": 2254,
    "企业已存在": 2255,
    "股份公司": 2256,
    "有限公司": 2257,
    "集团有限公司": 2258,
    "集团股份有限公司": 2259,
    "股份": 2260,
    "有限": 2261,
    "集团": 2262,
    "公司": 2263,
    "企业": 2264,
    "厂": 2265,
    "店": 2266,
    "馆": 2267,
    "部": 2268,
    "行": 2269,
    "中心": 2270,
    "中国": 2271,
    "中华": 2272,
    "国家": 2273,
    "更新企业信息": 2274,
    "当前客户": 2275,
    "未关联至任意组织内项目，确认要继续删除吗？": 2276,
    "客户": 2277,
    "删除后": 2278,
    "将自动从项目中移除客户信息": 2279,
    "当前客户已关联": 2280,
    "可在「项目列表」中筛选查看详情，确定要继续删除吗？": 2281,
    "确定要删除该客户吗？": 2282,
    "更新失败": 2283,
    "更新成功": 2284,
    "确定要将该人员设为离职吗？": 2285,
    "联系人「": 2286,
    "」将在企业「": 2287,
    "」下变为离职状态，确定要继续此操作吗？": 2288,
    "请维护联系人在此企业的就职时间（选填）": 2289,
    "不保留用户离职信息": 2290,
    "仅用于用户公司信息维护错误时进行修正使用": 2291,
    "确定离职": 2292,
    "确定移除": 2293,
    "客户详情": 2294,
    "联系人信息": 2295,
    "发行人": 2296,
    "保荐机构": 2297,
    "评估机构": 2298,
    "项目详情": 2299,
    "上市/发行日期": 2300,
    "联系表信息": 2301,
    "搜索行业代码/名称": 2302,
    "关联中介机构": 2303,
    "添加中介机构": 2304,
    "请选择机构": 2305,
    "请选择客户后点击确定": 2306,
    "该机构已被关联至此项目，请勿重复操作": 2307,
    "添加成功": 2308,
    "移除中介机构": 2309,
    "移除项目所关联的中介机构后，其下已被关联至此项目的联系人将会同步取消关联，确定要继续移除吗？": 2310,
    "移除成功": 2311,
    "关联通讯录联系人": 2312,
    "搜索联系人姓名": 2313,
    "关联联系人": 2314,
    "请输入联系人姓名后搜索": 2315,
    "联系人已被关联，请勿重复添加": 2316,
    "请输入联系人姓名后查询": 2317,
    "关联成功": 2318,
    "变更关联客户": 2319,
    "项目联系人": 2320,
    "查看联系人": 2321,
    "请选择客户后查看联系人": 2322,
    "确定变更关联客户吗？": 2323,
    "变更客户后，项目内成员将无法继续查看当前客户信息，确定要继续变更关联客户吗？": 2324,
    "关联机构": 2325,
    "已关联": 2326,
    "申请查看联系方式": 2327,
    "已申请查看": 2328,
    "操作助手": 2329,
    "按照以下步骤和我一起完成智慧云核心功能的操作使用吧": 2330,
    "遇到问题需要帮助？": 2331,
    "产品使用中遇到疑问，你可以向我们的产品专家在线进行询问": 2332,
    "在线咨询": 2333,
    "如何上传/新建文件？": 2334,
    "上传/新建文件": 2335,
    "「拖拽文件」到项目文档区域 或 点击「上传」按钮进行本地文件的上传，或 点击「新建」按钮进行文件新建的操作。": 2336,
    "如何对文件发起讨论？": 2337,
    "对文件发起讨论": 2338,
    "选中要发起讨论的文件，点击「发送到聊天」跳转至会话对象聊天窗口，可对发起讨论的文件进行文字说明，点击发送按钮即可。": 2339,
    "如何分享文件？": 2340,
    "选中要分享的文件，点击「外链分享」通过分享文档链接或二维码至相关人员进行查看文档内容。": 2341,
    "如何邀请项目成员？": 2342,
    "邀请项目成员": 2343,
    "点击右侧工具栏": 2344,
    "可快速邀请项目成员，邀请方式有三种：可通过1、链接邀请，2、手机号邀请，3、按群组邀请。": 2345,
    "新增「全局检索」功能": 2346,
    "新增对文件、联系人/群组、聊天记录的全局检索功能，点击全局检索入口或": 2347,
    "快速唤起全局检索弹框，可以对任意组织、任意项目中的文件、联系人进行检索": 2348,
    "关闭当前页": 2349,
    "关闭所有内容(共{}条)": 2350,
    "新功能上线": 2351,
    "新应用上架": 2352,
    "活动开始啦": 2353,
    "单独删除": 2354,
    "全部删除": 2355,
    "新增「项目文档窗体独立」功能": 2356,
    "将不同组织中不同项目的文档页面作为独立窗口打开，可以更快捷的实现跨组织/项目编辑和查看文件，你可以自由设置想要打开的项目文档，让文件编辑更加便捷、高效": 2357,
    "新增「文件收藏」功能": 2358,
    "你可以将近期经常使用或阶段性工作的文件添加到收藏，通过已收藏的文件快速找到项目文件并开始工作，提高在众多文件夹中查找目标文件的效率": 2359,
    "请选择中介机构名称": 2360,
    "点击选择业务类型": 2361,
    "字段获取错误，{}": 2362,
    "有时间": 2363,
    "无时间": 2364,
    "点击选择部门": 2365,
    "包含任一": 2366,
    "包含全部": 2367,
    "点击选择审批类型": 2368,
    "点击选择人员": 2369,
    "创建网查任务": 2370,
    "输入关键词搜索": 2371,
    "筛选": 2372,
    "链接": 2373,
    "添加筛选条件": 2374,
    "发送人": 2375,
    "@消息:": 2376,
    "请输入检索条件": 2377,
    "你可能想找": 2378,
    "最近联系过": 2379,
    "点击查看更多": 2380,
    "已展示全部结果": 2381,
    "没有找到关于": 2382,
    "群组": 2383,
    "群聊名称": 2384,
    "最近搜索": 2385,
    "选择{}": 2386,
    "未检索到数据": 2387,
    "标题": 2388,
    "匹配全部关键字 空格区分": 2389,
    "匹配任一关键词 空格区分": 2390,
    "不匹配关键词 空格区分": 2391,
    "结果展示顺序": 2392,
    "按时间排序": 2393,
    "按匹配度排序": 2394,
    "内容：": 2395,
    "匹配全部关键词 空格区分": 2396,
    "文档范围": 2397,
    "点击选择": 2398,
    "文件大小": 2399,
    "大小输入有误，请调整": 2400,
    "本次检索结果": 2401,
    "全部展开": 2402,
    "全部收起": 2403,
    "请先加入组织后，进行文件检索": 2404,
    "请输入检索条件后查询": 2405,
    "反馈": 2406,
    "网查工具使用体验调研": 2407,
    "感谢使用「智能网查」应用，为了进一步提升你的使用体验，请花2-3分钟时间反馈一下你使用「智能网查」的体验，产品后续怎么优化，想听听你的建议": 2408,
    "我要评论": 2409,
    "我要提建议": 2410,
    "我有产品需求": 2411,
    "请选择要评论的任务": 2412,
    "请评价你对本次任务执行的满意度": 2413,
    "1、网站满足需求程度": 2414,
    "2、查询结果满意程度": 2415,
    "3、查询结果精确程度": 2416,
    "4、查询速度满意程度": 2417,
    "5、操作易用性的满意程度": 2418,
    "你愿意推荐他人使用「智能网查」应用吗？": 2419,
    "其他问题评论": 2420,
    "还有其他问题要评论？请在这里输入": 2421,
    "上传图片附件": 2422,
    "图片支持jpg、png格式，最大不超过 5 M": 2423,
    "请选择问题分类": 2424,
    "问题描述": 2425,
    "需求标题": 2426,
    "请概述一下你的需求": 2427,
    "请描述一下该需求的业务场景和背景": 2428,
    "请具体描述一下你需要的是什么": 2429,
    "你的反馈对我们提升更好的使用体验有着至关重要的帮助，确定要离开吗？": 2430,
    "关于查询速度问题": 2431,
    "关于使用的便利性问题": 2432,
    "关于查询查询网站问题": 2433,
    "关于缺陷问题": 2434,
    "大于5M图片不可上传": 2435,
    "网查应用内": 2436,
    "{}的评论已提交成功": 2437,
    "移入此区域显示「刷新」，刷新该文件夹内容": 2438,
    "存在筛选条件": 2439,
    "请输入标题关键字 以空格区分": 2440,
    "在“项目文档”中搜索": 2441,
    "在“底稿视图”中搜索": 2442,
    "在\"{}...\"中搜索": 2443,
    "在\"{}\"中搜索": 2444,
    "开始": 2445,
    "系统通知": 2446,
    "加急消息": 2447,
    "基础信息": 2448,
    "请输入姓名,最多可输入10字符": 2449,
    "请选择性别": 2450,
    "手机": 2451,
    "已绑定": 2452,
    "未绑定": 2453,
    "需前往[荣大科技-账号安全]进行修改": 2454,
    "立即绑定": 2455,
    "请输入手机号": 2456,
    "不对外显示号码": 2457,
    "请输入邮箱": 2458,
    "请输入公司名称": 2459,
    "请输入部门": 2460,
    "请输入职位": 2461,
    "姓名不能为空": 2462,
    "手机不能为空": 2463,
    "性别不能为空": 2464,
    "不允许输入\\\\符号": 2465,
    "修改个人信息成功": 2466,
    "原密码": 2467,
    "请输入原密码": 2468,
    "密码为6-18位数字与字母组合": 2469,
    "新密码": 2470,
    "请输入新密码": 2471,
    "确认密码": 2472,
    "请再次输入新密码": 2473,
    "修改密码成功！请重新登录": 2474,
    "权益信息": 2475,
    "权益包大集合": 2476,
    "荣大公司交付的权益包集合，无需再次付费即可一键充值使用": 2477,
    "支持对权益包进行多次转让他人后充值使用，也方便查看权益包的使用详情": 2478,
    "前往查看": 2479,
    "账号注销": 2480,
    "信息": 2481,
    "共计提审": 2482,
    "请输入选择": 2483,
    "请输入申请内容": 2484,
    "抄送方式": 2485,
    "审批通过后通知": 2486,
    "将会对底稿管理中选中目录发起审批": 2487,
    "将会对项目文档中选中文件发起审批": 2488,
    "将会对底稿视图中选中文件发起审批": 2489,
    "您暂无项目权限，不可发起审批": 2490,
    "请到底稿管理选择目录后发起审批": 2491,
    "请到项目文档/底稿管理选择文件后发起审批": 2492,
    "当前无选中{}": 2493,
    "归档文件无法发起审批": 2494,
    "所选文件中存在锁定文件，无法发起审批": 2495,
    "请先选择可审批的{}": 2496,
    "发起审批时，归档文件将自动过滤，确定要继续操作吗？": 2497,
    "仅审批通过的{}可发起修订审批": 2498,
    "仅审批通过的{}可发起审批，其他{}将自动过滤": 2499,
    "确认关闭": 2500,
    "请勾选想要删除的附件": 2501,
    "{}文件已存在": 2502,
    "请选部门": 2503,
    "提交审批成功": 2504,
    "收藏项目": 2505,
    "修改备注名": 2506,
    "独立项目窗口": 2507,
    "独立窗口数量已达上限": 2508,
    "最多可同时打开{}个独立窗口，请关闭其他已打开窗口再操作": 2509,
    "关联索引": 2510,
    "排序": 2511,
    "已选中": 2512,
    "项": 2513,
    "文件编辑模式支持「本地编辑」或「多人编辑」": 2514,
    "编辑预览说明": 2515,
    "本地编辑模式或多人编辑模式通过开关进行切换": 2516,
    "显示为仅可预览或不可预览的文件格式，不支持本地/多人编辑": 2517,
    "多人": 2518,
    "本地": 2519,
    "确定切换到「多人编辑模式」吗？": 2520,
    "该模式不兼容部分office功能，对文档排版格式有影响，确定继续切换吗？": 2521,
    "在线编辑模式": 2522,
    "本地编辑模式": 2523,
    "仅可预览": 2524,
    "不可预览": 2525,
    "正在保存": 2526,
    "备注{}条": 2527,
    "文件已删除，不能预览": 2528,
    "文件名已存在，新文件将以「{}」进行命名": 2529,
    "是否同步修改任务名称？": 2530,
    "请选择一个项目进行操作": 2531,
    "新建中": 2532,
    "{} 的 {}": 2533,
    "{}的{}": 2534,
    "的": 2535,
    "日志抄送人": 2536,
    "暂无抄送人": 2537,
    "复用该日志": 2538,
    "{}的{}日志": 2539,
    "确定要复用该日志吗？": 2540,
    "有正在编辑的草稿内容，当前操作将清空所有内容，确定要继续操作吗？": 2541,
    "复用日志": 2542,
    "数据获取失败，请关闭窗口重试": 2543,
    "暂无可复用的日志": 2544,
    "超出最大人数限制": 2545,
    "按组织架构选择": 2546,
    "按项目选择": 2547,
    "接口信息获取失败": 2548,
    "当前组织下无成员和子部门": 2549,
    "当前组织下无项目": 2550,
    "按组织结构选择": 2551,
    "{}({}人)": 2552,
    "按成员选择": 2553,
    "已存在": 2554,
    "底稿管理-{}审批意见页": 2555,
    "项目文档-文件审批意见页": 2556,
    "请选择{}": 2557,
    "将要删除文件": 2558,
    "关联文件位置": 2559,
    "被索引情况": 2560,
    "解锁中": 2561,
    "上锁时间": 2562,
    "锁类型": 2563,
    "锁定人": 2564,
    "正在解锁": 2565,
    "文件位置": 2566,
    "手动锁定": 2567,
    "异常锁定": 2568,
    "系统锁定": 2569,
    "我锁定的": 2570,
    "他人锁定的": 2571,
    "由项目成员进行手动锁定的文件": 2572,
    "系统检测到无人正在进行编辑，但文件并未正常解锁的情况，将被识别为文件异常锁定": 2573,
    "系统检测到正在进行编辑的文件，或因业务操作被系统锁定的文件不可被解锁": 2574,
    "操作失败": 2575,
    "本地编辑锁定": 2576,
    "多人编辑锁定": 2577,
    "搜索结果页不可以使用目录模板": 2578,
    "请先选择项目": 2579,
    "引用成功": 2580,
    "请选择想要复制的文件或文件夹": 2581,
    "当前无选中文件": 2582,
    "归档文件不可拖动剪切": 2583,
    "搜索结果页不允许剪切": 2584,
    "剪切成功": 2585,
    "已删除的文件可通过回收站还原，该文件已关联底稿文件": 2586,
    "关联的底稿文件将无法还原，确定要继续删除吗？": 2587,
    "确认要把文件放入回收站吗？文件已关联为底稿文件，将一同删除，删除的文件可随时在回收站里还原，但关联文件不能还原。": 2588,
    "正在删除...": 2589,
    "删除成功，删除的文档可以从「回收站」中恢复": 2590,
    "审批中的文件不能删除，请重新选择。": 2591,
    "审批通过的文件不能删除，请重新选择。": 2592,
    "确定要删除选中的内容吗？": 2593,
    "路径": 2594,
    "已删除的文件/文件夹可通过回收站还原，确定要继续删除吗？": 2595,
    "此操作仅删除底稿文件，项目文档中的原始文件不受影响，确定要继续删除吗？": 2596,
    "已删除的文件/文件夹将无法恢复，确定要继续删除吗？": 2597,
    "已添加至收藏！": 2598,
    "没有可上锁的数据": 2599,
    "批量上锁成功": 2600,
    "该文件已加锁": 2601,
    "审批中/审批通过的文件不可手动解锁！": 2602,
    "该文件已锁定，是否解锁": 2603,
    "确定要锁定该文件吗？": 2604,
    "锁定后，该文件无法编辑，确定要锁定吗？": 2605,
    "取消锁定": 2606,
    "搜索结果页不允许新建": 2607,
    "使用PDF Reader Pro与PDF Reader，未编辑内容关闭文件；": 2608,
    "使用浏览器编辑PDF文件；": 2609,
    "上述两种方式会造成文件锁定异常，需通过人工手动解除锁定。": 2610,
    "请确认本地已经安装pdf编辑软件": 2611,
    "未安装时进行本地编辑会造成文件锁定异常，需通过人工手动解除锁定": 2612,
    "继续编辑": 2613,
    "使用Numbers表格、Pages文稿、Keynote讲演进行单人本地编辑时，无法自动生成新版本，您可以采用手动上传的方式将本地已经编辑完成的文件进行上传。": 2614,
    "终止项目不支持引用模板": 2615,
    "搜索结果页不允许引用在线模板": 2616,
    "搜索结果页不允许粘贴": 2617,
    "请先选择目录": 2618,
    "请先复制粘贴文件": 2619,
    "请先复制文件或文件夹": 2620,
    "不能跨项目剪切": 2621,
    "请先复制文件": 2622,
    "正在剪切": 2623,
    "索引粘贴成功": 2624,
    "选择接收人": 2625,
    "仅支持勾选一个": 2626,
    "请先选择文件": 2627,
    "文件解锁成功": 2628,
    "无法对文件夹进行备注，请选择要备注的文件": 2629,
    "已选文件列表": 2630,
    "关键字": 2631,
    "包含以下全部关键字(以空格区分)": 2632,
    "请选择项目阶段": 2633,
    "已修订": 2634,
    "索引": 2635,
    "不可操作": 2636,
    "所在阶段": 2637,
    "所在目录": 2638,
    "生成": 2639,
    "底稿关联": 2640,
    "我的审批-{}审批-版本": 2641,
    "文件审批搜索结果": 2642,
    "有讨论的": 2643,
    "文件/文件夹": 2644,
    "目录修订审批": 2645,
    "{}搜索结果": 2646,
    "系统异常": 2647,
    "主工作台-我的审批-审批-审批记录": 2648,
    "请选择文件后点击版本": 2649,
    "请选择单个文件后点击版本": 2650,
    "当前无选中目录": 2651,
    "我的审批-{}审批-{}审批意见页": 2652,
    "该{}{},无法再进行审批": 2653,
    "该{}已被其他节点驳回,无法再进行审批": 2654,
    "请先选择可审批的目录": 2655,
    "已在其他审批中进行/审批通过的文件不能再进行审批，进行审批时将自动过滤。源文件及索引文件进行审批时，所有审批意见及审批状态将进行同步?": 2656,
    "已在其他审批中进行/审批通过的目录和本次未提审的待审批目录不能进行审批，进行审批时将自动过滤": 2657,
    "审批确认": 2658,
    "请先选择可审批的文件": 2659,
    "{}审批": 2660,
    "{}审批意见": 2661,
    "我的审批-{}审批-备注": 2662,
    "{}审批查询": 2663,
    "{}/{}/{}审批查询": 2664,
    "请选中{}后点击下载": 2665,
    "我的审批-{}审批": 2666,
    "当前无选中{}，请选择您要导出的{}": 2667,
    "我的审批-文件审批-文件审批搜索结果": 2668,
    "相关信息": 2669,
    "共计": 2670,
    "，已审": 2671,
    "个，待审": 2672,
    "去审": 2673,
    "）个": 2674,
    "节点审批": 2675,
    "文件修订审批意见": 2676,
    "目录修订审批意见": 2677,
    "转交": 2678,
    "请输入审批意见，最多输入1000字": 2679,
    "抄送人(抄送方式:整体审批完成后抄送)": 2680,
    "新建日程提醒": 2681,
    "我的审批-{}审批-节点审批-{}审批意见页": 2682,
    "所属行业": 2683,
    "成立时间": 2684,
    "联系电话": 2685,
    "所属部门": 2686,
    "团队信息": 2687,
    "借阅信息": 2688,
    "记录": 2689,
    "抄送人：": 2690,
    "级审批": 2691,
    "审批时间：": 2692,
    "审批文件": 2693,
    "文件审批记录": 2694,
    "平方根几号放假": 2695,
    "关联会议": 2696,
    "选择会议": 2697,
    "请选择会议": 2698,
    "我选中的会议": 2699,
    "新增会议": 2700,
    "取消关联提醒": 2701,
    "关联投票": 2702,
    "选择投票": 2703,
    "请选择投票": 2704,
    "我选中的投票": 2705,
    "新增投票": 2706,
    "取消投票关联提醒": 2707,
    "没有关联的投票": 2708,
    "请输入投票名称": 2709,
    "只能上传jpg/png文件，且不超过500kb": 2710,
    "转交人员": 2711,
    "请输入转交理由": 2712,
    "最多输入400字": 2713,
    "请选择转交人员": 2714,
    "会议主题内容不能为空": 2715,
    "会议类型内容不能为空": 2716,
    "结束时间不能为空": 2717,
    "参会人员不能为空": 2718,
    "取消成功!": 2719,
    "已取消": 2720,
    "是否取消该关联投票": 2721,
    "投票人员不能为空": 2722,
    "{}小时": 2723,
    "待审目录": 2724,
    "请选择审批结果": 2725,
    "请审批文件": 2726,
    "请审批目录": 2727,
    "当前附件全部未通过": 2728,
    "{}提醒您审批他的{}": 2729,
    "确认要撤销审批吗？": 2730,
    "主工作台": 2731,
    "撤销": 2732,
    "催办": 2733,
    "去审文件": 2734,
    "去审目录": 2735,
    "审批结果：": 2736,
    "此审批流程要求您要有关联的投票": 2737,
    "选择抄送人员": 2738,
    "您有未审批文件，请全部审批": 2739,
    "{} ：提醒您尽快审批关于{}{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为{}": 2740,
    "请输入名称": 2741,
    "请输入所属项目": 2742,
    "类型": 2743,
    "请选择类型": 2744,
    "事件名称": 2745,
    "事件类型": 2746,
    "日程抄送设置": 2747,
    "请选择抄送人": 2748,
    "新建日程": 2749,
    "默认通过站内信通知发送给对方，点击{}删除": 2750,
    "抄送我的日程": 2751,
    "周": 2752,
    "年": 2753,
    "开始前15分钟": 2754,
    "开始前1小时": 2755,
    "开始前3小时": 2756,
    "开始前1天": 2757,
    "结束日期不能小于于开始日期": 2758,
    "当前有草稿内容，是否要引用？": 2759,
    "内容不能为空": 2760,
    "七": 2761,
    "八": 2762,
    "九": 2763,
    "十": 2764,
    "十一": 2765,
    "十二": 2766,
    "从借阅成功起，借阅时限为{}小时超过借阅时限后": 2767,
    "借阅文件": 2768,
    "自动失效": 2769,
    "无法查看": 2770,
    "是否确定借阅？": 2771,
    "请输入项目编码": 2772,
    "访问来源": 2773,
    "移除全部已删除文件": 2774,
    "已取消收藏": 2775,
    "已移除": 2776,
    "待检验目录": 2777,
    "更改位置": 2778,
    "目录文件": 2779,
    "选择文件": 2780,
    "校验规则": 2781,
    "检验列: sheet 1, A列": 2782,
    "请选择待检验目录": 2783,
    "请选择目录文件": 2784,
    "文件大小超出限制，上限为10M": 2785,
    "目录检验中，完成后将推送系统消息，请稍后...": 2786,
    "待提取目录": 2787,
    "提取文件保存位置": 2788,
    "[Excel提取文件]": 2789,
    "请选择待提取目录": 2790,
    "请选择提取文件保存位置": 2791,
    "文件提取中，完成后将推送系统消息，请稍后...": 2792,
    "待导出目录": 2793,
    "导出内容": 2794,
    "文件 + 文件夹": 2795,
    "请选择待导出目录": 2796,
    "执行失败,请重试": 2797,
    "目录导出中，完成后将推送系统消息，请稍后...": 2798,
    "功能演示": 2799,
    "tips: 需等数分钟, 检验完成后将推送消息": 2800,
    "tips: 导出的目录只支持当下的50个层级": 2801,
    "检测": 2802,
    "提取": 2803,
    "检验": 2804,
    "创建群聊": 2805,
    "创建项目群": 2806,
    "不允许上传文件夹": 2807,
    "所要加入项目": 2808,
    "手机号邀请": 2809,
    "按群组邀请": 2810,
    "组织成员席位": 2811,
    "请输入正确格式的手机号": 2812,
    "请选择邀请人员": 2813,
    "搜索日志模板标题": 2814,
    "最近使用": 2815,
    "更多模板": 2816,
    "看成是大家": 2817,
    "看fsd": 2818,
    "擦第三方ads": 2819,
    "项目统计{}进度状态{}": 2820,
    "项目进度": 2821,
    "项目编号": 2822,
    "负责人": 2823,
    "整体完成度": 2824,
    "事项名称": 2825,
    "事项类型": 2826,
    "最新消息": 2827,
    "{}的项目日志": 2828,
    "的项目日志": 2829,
    "会议名称": 2830,
    "结束日期不能小于开始日期": 2831,
    "设置提醒后，有版本变动的文件将会在\"消息中心\"红点标记提醒！": 2832,
    "关闭提醒后，该文件对所有人的提醒均关闭！": 2833,
    "提醒人员": 2834,
    "添加人员": 2835,
    "添加角色": 2836,
    "选择的文件": 2837,
    "关闭提醒": 2838,
    "未选中要关闭的文件": 2839,
    "您已成功关闭本人设置的文件提醒": 2840,
    "请在提醒人员中添加人员或者角色": 2841,
    "请重新选择要提醒的文件": 2842,
    "文件设置提醒成功": 2843,
    "批量编辑关联": 2844,
    "选择要创建关联的文件": 2845,
    "请输入关键词搜索": 2846,
    "选择要关联的目标文件": 2847,
    "底稿文档": 2848,
    "右侧只能选择一个文件": 2849,
    "请选择要创建关联的文件": 2850,
    "请选择要关联的目标文件": 2851,
    "{}不能关联本身": 2852,
    "编辑底稿关联": 2853,
    "此文件已是锁定状态，不能再次添加": 2854,
    "文件不能关联本身": 2855,
    "已删除的文件不能被关联": 2856,
    "全文检索": 2857,
    "所在项目": 2858,
    "搜索条件不能为空": 2859,
    "首页": 2860,
    "借阅剩余时限": 2861,
    "已经到底了~": 2862,
    "{}分钟": 2863,
    "请选中数据进行下载或批量下载(注：锁定文件和不可操作文件是不能下载的)": 2864,
    "所选数据包含锁定文件不能删除": 2865,
    "此操作将永久删除该文件, 是否继续?": 2866,
    "数据过多正在删除中": 2867,
    "请选择数据进行删除": 2868,
    "此处删除只能删除单条": 2869,
    "所选数据包含锁定文件不能重命名": 2870,
    "名字不能为空": 2871,
    "所选数据包含锁定文件不能剪切": 2872,
    "当前选中有目录数据,暂不支持目录的剪切操作": 2873,
    "当前文件锁定成功": 2874,
    "当前文件未能锁定成功": 2875,
    "此处锁定只能锁定单条": 2876,
    "当前文件解锁成功": 2877,
    "当前文件未能解锁成功": 2878,
    "删除成功(含有文件锁或特殊文件是不允许删除的)": 2879,
    "编辑失败": 2880,
    "您确定要使用{}来当作文件的名字": 2881,
    "粘贴成功": 2882,
    "服务评价": 2883,
    "请对本次服务进行评价,您的评价有助于我们为您提供更好的服务!": 2884,
    "服务人员": 2885,
    "服务类型": 2886,
    "服务项目": 2887,
    "产品质量": 2888,
    "服务态度": 2889,
    "工作效率": 2890,
    "专业技能": 2891,
    "服务描述": 2892,
    "请您对本次服务做出评价最对200个字": 2893,
    "收藏此服务员": 2894,
    "匿名评价": 2895,
    "提交评价": 2896,
    "讨论对象": 2897,
    "待我执行({})": 2898,
    "抄送我的({})": 2899,
    "我创建的({})": 2900,
    "我完成的({})": 2901,
    "取消完成": 2902,
    "标记完成": 2903,
    "上次打开": 2904,
    "搜索任务名称": 2905,
    "请选择任务": 2906,
    "是否要取消完成所有选中的任务 是否继续?": 2907,
    "{}个任务取消成功，{}个任务取消失败": 2908,
    "确定要标记完成所有选中的任务吗？": 2909,
    "标记": 2910,
    "全部{}成功": 2911,
    "{}个任务{}成功，{}个任务{}失败": 2912,
    "任务不存在": 2913,
    "创建或加入组织": 2914,
    "创建属于你的组织，邀请成员一起协作办公，或点击": 2915,
    "现在，从新建一个项目开始全面使用智慧云吧": 2916,
    "开启智慧云文档、任务等核心功能，并邀请成员一起在线协作": 2917,
    "席位": 2918,
    "试用版永久免费": 2919,
    "拖拽排序": 2920,
    "可对任务进行拖拽排序": 2921,
    "更多选项": 2922,
    "Excel模板": 2923,
    "导入模板": 2924,
    "全部任务(含附件)": 2925,
    "仅任务总览": 2926,
    "导出任务": 2927,
    "默认顺序": 2928,
    "恢复任务初始顺序": 2929,
    "还原顺序": 2930,
    "还原移动前顺序": 2931,
    "高级": 2932,
    "请输入任务名称,多个请用空格隔开": 2933,
    "点击选择创建人": 2934,
    "请选择优先级": 2935,
    "请选择逾期状态": 2936,
    "请选择任务状态": 2937,
    "看板视图": 2938,
    "列表视图": 2939,
    "概览视图": 2940,
    "进行中": 2941,
    "逾期进行中": 2942,
    "逾期已完成": 2943,
    "待我执行": 2944,
    "我创建的": 2945,
    "我完成的": 2946,
    "全部任务(0)": 2947,
    "导入成功": 2948,
    "无任务导出": 2949,
    "网页端暂不支持此功能，请下载客户端操作": 2950,
    "定位项目群": 2951,
    "快速打开当前项目群聊窗口": 2952,
    "查看当前已打开项目任务": 2953,
    "邀请更多人员加入当前项目": 2954,
    "是否打开消息独立窗口并定位到对应的项目群？": 2955,
    "去到消息页面": 2956,
    "请先加入项目": 2957,
    "暂无邀请权限，请去联系项目创建人": 2958,
    "进行配置": 2959,
    "删除时间": 2960,
    "请选取至少一条数据": 2961,
    "您确定要还原文件？": 2962,
    "还原中...": 2963,
    "您确定要彻底删除文件？": 2964,
    "您确定要清空回收站？清空后文件将无法恢复": 2965,
    "清空回收站成功!": 2966,
    "个人网盘搜索结果页": 2967,
    "已使用空间": 2968,
    "没有说明": 2969,
    "版本名称": 2970,
    "请输入版本名称，如：1.0": 2971,
    "升级类型": 2972,
    "请选择升级类型": 2973,
    "不强制升级": 2974,
    "强制升级": 2975,
    "静默升级": 2976,
    "是否包含前端包": 2977,
    "请选择包含前端包": 2978,
    "不包含": 2979,
    "升级的环境": 2980,
    "请选择需要升级的环境": 2981,
    "开发": 2982,
    "测试": 2983,
    "产研": 2984,
    "正式": 2985,
    "环境ip": 2986,
    "跟升级环境对应的ip": 2987,
    "升级包地址": 2988,
    "请输入升级包地址": 2989,
    "pc升级验证": 2990,
    "请输入pc升级验证": 2991,
    "发布时间": 2992,
    "请选择产品的发布时间": 2993,
    "升级说明 {}": 2994,
    "请直接输入说明，注意不要输入序号！": 2995,
    "新增说明项": 2996,
    "删除此说明项": 2997,
    "请输入版本名称": 2998,
    "请选择是否包含前端包": 2999,
    "请选择升级环境": 3000,
    "请输入跟升级环境对应的ip": 3001,
    "请选择发布时间": 3002,
    "升级说明不允许为空": 3003,
    "此操作将永久删除该记录, 是否继续?": 3004,
    "升级标识": 3005,
    "请选择升级标识": 3006,
    "不用升级": 3007,
    "可选升级": 3008,
    "下载链接": 3009,
    "文案描述": 3010,
    "平台信息": 3011,
    "请选平台信息": 3012,
    "版本号不能为空": 3013,
    "版本号为数字": 3014,
    "升级标识不能为空": 3015,
    "下载链接不能为空": 3016,
    "文案描述不能为空": 3017,
    "平台信息不能为空": 3018,
    "新增失败": 3019,
    "下级部门": 3020,
    "增加子部门": 3021,
    "部门名称": 3022,
    "上移": 3023,
    "下移": 3024,
    "部门成员": 3025,
    "增加人员": 3026,
    "调整部门": 3027,
    "是否部门主管": 3028,
    "增加部门名称": 3029,
    "投资银行部": 3030,
    "请选择成员": 3031,
    "确定删除该人员吗?": 3032,
    "删除提示": 3033,
    "已经是第一条了": 3034,
    "已经是最后一条": 3035,
    "名称不能为空": 3036,
    "删除部门会删除部门下的所有子部门以及人员, 确定删除吗?": 3037,
    "新建流程": 3038,
    "版本管理": 3039,
    "流程名称": 3040,
    "变更理由": 3041,
    "是否为主版本": 3042,
    "主版本": 3043,
    "设置主版本": 3044,
    "人员配置": 3045,
    "审批人员": 3046,
    "选择用户": 3047,
    "无主管时，可由上级主管代批": 3048,
    "注：审批人为空时自动转交给管理员。": 3049,
    "已发布": 3050,
    "直接主管（1级主管）": 3051,
    "2级主管": 3052,
    "3级主管": 3053,
    "4级主管": 3054,
    "5级主管": 3055,
    "设置成功": 3056,
    "主版本不可删除": 3057,
    "此操作将永久删除该流程, 是否继续?": 3058,
    "请选择人员配置": 3059,
    "请选择指定用户": 3060,
    "请选择指定角色": 3061,
    "流程引擎搜索结果": 3062,
    "新增流程": 3063,
    "请输入关键词": 3064,
    "请先选择业务类型": 3065,
    "请选择一个业务类型": 3066,
    "开启流程审批": 3067,
    "关闭流程审批": 3068,
    "关联项目审批": 3069,
    "关闭关联项目审批": 3070,
    "描述": 3071,
    "流程": 3072,
    "保存并关闭": 3073,
    "未发布": 3074,
    "禁用中": 3075,
    "启用中": 3076,
    "去补充": 3077,
    "编辑流程": 3078,
    "请先保存修改内容": 3079,
    "只有状态为启用中的时候才能开启审批流程": 3080,
    "开启审批流程": 3081,
    "关闭审批流程": 3082,
    "只有开启审批流程之后才能开起关联项目审批": 3083,
    "开启关联审批流程": 3084,
    "关闭关联审批流程": 3085,
    "发布成功": 3086,
    "启用成功": 3087,
    "禁用成功": 3088,
    "所选审批人中{}": 3089,
    "{}抄送人中{}": 3090,
    "账号异常，请先编辑处理，否则将可能导致审批流程无法正常进行。": 3091,
    "流程图不完整无法启用该审核，请补充流程图": 3092,
    "业务类型内容不能为空": 3093,
    "审核类型内容不能为空！": 3094,
    "项目阶段内容不能为空": 3095,
    "保存成功": 3096,
    "请先选择流程": 3097,
    "请至少选择一条数据": 3098,
    "请先复制流程": 3099,
    "搜索角色": 3100,
    "无匹配数据": 3101,
    "创建角色副本": 3102,
    "可操作功能": 3103,
    "可访问数据": 3104,
    "项目数据": 3105,
    "客户数据": 3106,
    "个人日志数据": 3107,
    "数据源": 3108,
    "请先复制角色权限": 3109,
    "创建角色副本成功": 3110,
    "请选择权限": 3111,
    "请输入角色名称": 3112,
    "角色名称不能超过20个字符": 3113,
    "确定要删除选中的角色吗？": 3114,
    "请输入正确的角色名称": 3115,
    "选择时间": 3116,
    "日志分类": 3117,
    "请选日志分类": 3118,
    "底稿报送": 3119,
    "事件内容": 3120,
    "包含以下全部关键词（以空格区分）": 3121,
    "包含以下全部关键词（以空格区分": 3122,
    "操作用户": 3123,
    "请选择用户": 3124,
    "历史年度数据导出": 3125,
    "用户名": 3126,
    "选择导出年度": 3127,
    "导出当年": 3128,
    "上一年": 3129,
    "选择年": 3130,
    "工作": 3131,
    "用户": 3132,
    "检索日志": 3133,
    "组织消息": 3134,
    "开始时间不能晚于结束时间": 3135,
    "结束时间不能早于开始时间": 3136,
    "请输入开始日期": 3137,
    "请输入结束日期": 3138,
    "开始日期不能大于当前日期": 3139,
    "结束日期不能小于当前日期": 3140,
    "正在导出": 3141,
    "请选择时间": 3142,
    "角色": 3143,
    "退出时间": 3144,
    "拒绝": 3145,
    "荣大": 3146,
    "荣大-人员": 3147,
    "该操作将该成员取消邀请，是否继续？": 3148,
    "取消邀请成功": 3149,
    "员工名称": 3150,
    "请输入关键字,多个请用空格隔开": 3151,
    "离开时间": 3152,
    "已加入": 3153,
    "邀请中": 3154,
    "申请中": 3155,
    "请选择角色": 3156,
    "请选中人员": 3157,
    "系统异常, 请刷新页面": 3158,
    "同意成功": 3159,
    "拒绝成功": 3160,
    "修改人员": 3161,
    "请输入姓名": 3162,
    "姓名长度不能超过20": 3163,
    "请填写完整资料": 3164,
    "手机号格式错误，请重试": 3165,
    "身份证号不正确，请重试": 3166,
    "职位输入有误，职位名由汉字或字母组成": 3167,
    "确定要删除{}吗, 是否继续?": 3168,
    "收回独立窗口": 3169,
    "置顶独立窗口": 3170,
    "搜索组织": 3171,
    "上次组织": 3172,
    "全部组织": 3173,
    "项目名称:": 3174,
    "快速 「切换组织项目」 上线啦": 3175,
    "可切换其他组织下的项目": 3176,
    "变更时间": 3177,
    "变更日志": 3178,
    "客户姓名": 3179,
    "客户变更": 3180,
    "联系人变更": 3181,
    "新增": 3182,
    "项目关联": 3183,
    "推送列表": 3184,
    "推送名称": 3185,
    "执行状态": 3186,
    "推送内容": 3187,
    "用户名称": 3188,
    "请输入用户名称": 3189,
    "发送时间": 3190,
    "再次发送": 3191,
    "确定要再次发送此推送消息吗？": 3192,
    "发送成功": 3193,
    "发送中，合计发送 {} 人": 3194,
    "已完成，合计发送 {} 人，失败 {} 人": 3195,
    "正在导出!": 3196,
    "新建推送": 3197,
    "推送名称：": 3198,
    "请输入推送名称": 3199,
    "请输入创建人": 3200,
    "发送中，合计发送{}人": 3201,
    "已完成，合计发送{}人，失败{}人": 3202,
    "推送次数": 3203,
    "发送详情": 3204,
    "发送主体设置": 3205,
    "发送主体": 3206,
    "系统广告": 3207,
    "系统活动": 3208,
    "请选择接收人": 3209,
    "是否发送全局消息通知？": 3210,
    "发送链接为:": 3211,
    "内容设置": 3212,
    "请输入推送名称 (不超过字)": 3213,
    "有效期": 3214,
    "分享卡片标题": 3215,
    "分享卡片内容": 3216,
    "通知内容": 3217,
    "传输协议": 3218,
    "站内跳转": 3219,
    "ibsaasActivity.html为默认活动页路径": 3220,
    "APP推广通知": 3221,
    "请选择终端": 3222,
    "安卓": 3223,
    "立即创建": 3224,
    "图片未找到": 3225,
    "输入的字符不能超过{} 个！": 3226,
    "请输入系统通知信息": 3227,
    "输入的字符不能超过{}个！": 3228,
    "请输入有效期": 3229,
    "链接不能为空": 3230,
    "请输入卡片标题": 3231,
    "输入的字符不能超过200 个！": 3232,
    "请输入卡片内容": 3233,
    "活动类型下需要上传推广图片": 3234,
    "接收人设置（必选项）": 3235,
    "按用户推送": 3236,
    "用户姓名": 3237,
    "用户手机号": 3238,
    "添加一行": 3239,
    "批量导入": 3240,
    "按终端推送": 3241,
    "终端": 3242,
    "导入失败，请上传符合模板的Excel文件（xls、xlsx）": 3243,
    "当前文件过大，请上传4M以内的文件，格式包括xls、xlsx": 3244,
    "重新上传": 3245,
    "注销账号操作不可逆，请谨慎操作！": 3246,
    "永久注销当前账号，注销成功后该账号将无法使用，账号下的所有数据将被删除": 3247,
    "你正在申请注销当前账号。注销后，你将退出": 3248,
    "「荣大相关系列产品」且不能登录，如有付费产品也将一并取消，": 3249,
    "该账号将无法使用且无法恢复，账号下的所有数据也将被删除。确定要继续注销操作吗？": 3250,
    "注销前，请先移交或删除组织": 3251,
    "移交": 3252,
    "暂不注销": 3253,
    "继续注销": 3254,
    "已付费": 3255,
    "已到期": 3256,
    "账号注销成功": 3257,
    "账号注销失败": 3258,
    "移交项目": 3259,
    "删除项目": 3260,
    "删除项目后将无法恢复，请谨慎操作": 3261,
    "退出项目": 3262,
    "退出后将无法查看团队内容": 3263,
    "搜索目录": 3264,
    "文件名已存在，新文件将以{}进行命名": 3265,
    "确定要删除底稿目录吗？": 3266,
    "当前目录下的所有内容将被删除且无法恢复，确定要继续删除吗？": 3267,
    "全部下底稿上传不允许新建文件夹": 3268,
    "新建成功": 3269,
    "信息加载失败，请点击按钮重新加载": 3270,
    "搜索部门": 3271,
    "搜索职务": 3272,
    "手机号码": 3273,
    "电话": 3274,
    "新建客户联系人": 3275,
    "股东信息": 3276,
    "合作记录": 3277,
    "客户文档": 3278,
    "新增机构": 3279,
    "搜索机构编码/机构名称/机构简称": 3280,
    "新增中介机构": 3281,
    "机构信息": 3282,
    "请输入机构名称": 3283,
    "请输入机构简称": 3284,
    "请选择机构类型": 3285,
    "请输入机构联系人": 3286,
    "请输入客户负责人": 3287,
    "请输入联系电话": 3288,
    "传真": 3289,
    "请输入传真": 3290,
    "邮编": 3291,
    "请输入邮编": 3292,
    "办公地址": 3293,
    "请输入办公地址": 3294,
    "机构网址": 3295,
    "请输入机构网址": 3296,
    "机构简介": 3297,
    "请输入机构简介": 3298,
    "确定删除这条信息吗": 3299,
    "请输入机构编码,多个请用空格隔开": 3300,
    "请输入机构名称,多个请用空格隔开": 3301,
    "请输入机构简称,多个请用空格隔开": 3302,
    "请选择客户负责人": 3303,
    "请选择客户创建人": 3304,
    "机构名称内容不能为空": 3305,
    "机构简称内容不能为空": 3306,
    "机构类型内容不能为空": 3307,
    "机构联系人内容不能为空": 3308,
    "客户负责人内容不能为空": 3309,
    "联系电话内容不能为空": 3310,
    "邮箱格式错误": 3311,
    "传真有误，请重填": 3312,
    "我的企业客户": 3313,
    "搜索客户编码/客户名称": 3314,
    "行业(1级)": 3315,
    "行业(2级)": 3316,
    "行业(3级)": 3317,
    "行业(4级)": 3318,
    "新增企业客户": 3319,
    "请输入客户名称": 3320,
    "客户简称": 3321,
    "请输入客户简称": 3322,
    "上级客户": 3323,
    "请输入客户编码搜索": 3324,
    "客户地区": 3325,
    "请选择客户状态": 3326,
    "选择上市板块": 3327,
    "上市时间": 3328,
    "请输入法人代表": 3329,
    "请输入注册资本": 3330,
    "公司网址": 3331,
    "请输入公司网址": 3332,
    "公司简介": 3333,
    "请输入公司简介": 3334,
    "经营范围": 3335,
    "请输入经营范围": 3336,
    "请输入地址": 3337,
    "企业客户重名提示": 3338,
    "当前已存在{}个名称为{}的企业客户，客户创建人为{}": 3339,
    "是否创建同名新客户？客户编码将作为该客户唯一标识": 3340,
    "创建新客户": 3341,
    "请输入客户编码,多个请用空格隔开": 3342,
    "客户名称内容不能为空": 3343,
    "我的自然人客户": 3344,
    "新增自然人客户": 3345,
    "客户中文名：": 3346,
    "客户英文名：": 3347,
    "上级客户：": 3348,
    "客户地区：": 3349,
    "客户国籍：": 3350,
    "请选择客户国籍": 3351,
    "请选择客户学历": 3352,
    "客户性别：": 3353,
    "出生日期：": 3354,
    "身份证号码：": 3355,
    "请输入身份证号码": 3356,
    "客户状态：": 3357,
    "自然人重名提示": 3358,
    "硕士": 3359,
    "博士": 3360,
    "埃及": 3361,
    "爱尔兰": 3362,
    "奥地利": 3363,
    "澳大利亚": 3364,
    "巴西": 3365,
    "波兰": 3366,
    "德国": 3367,
    "俄国": 3368,
    "法国": 3369,
    "芬兰": 3370,
    "韩国": 3371,
    "荷兰": 3372,
    "加拿大": 3373,
    "美国": 3374,
    "尼日利亚": 3375,
    "挪威": 3376,
    "葡萄牙": 3377,
    "日本": 3378,
    "瑞国": 3379,
    "瑞士": 3380,
    "苏格兰": 3381,
    "泰国": 3382,
    "威尔士": 3383,
    "西班牙": 3384,
    "希腊": 3385,
    "新西兰": 3386,
    "以色列": 3387,
    "意大利": 3388,
    "印度": 3389,
    "英国": 3390,
    "客户中文名内容不能为空": 3391,
    "客户性别为必选": 3392,
    "客户出生日期不能为空": 3393,
    "客户身份证号错误": 3394,
    "客户类型内容不能为空": 3395,
    "联系电话不能为空": 3396,
    "客户状态内容不能为空": 3397,
    "原讨论文件都已删除": 3398,
    "请输入文件/文件夹名称": 3399,
    "位置": 3400,
    "删除人": 3401,
    "文件夹不支持预览": 3402,
    "确定要清空回收站吗？": 3403,
    "回收站清空后，文件将无法恢复，确定要清空吗？": 3404,
    "清空回收站成功！": 3405,
    "确定要还原文件吗？": 3406,
    "批量删除": 3407,
    "确定要彻底删除文件吗？": 3408,
    "讨论的文件已更换目录位置，请回到合集中选择单文件的定位": 3409,
    "成员管理": 3410,
    "已修改的内容尚未保存，确定退出吗": 3411,
    "文件已删除": 3412,
    "搜索客户名称": 3413,
    "拜访日期": 3414,
    "请输入拜访地点,多个请用空格隔开": 3415,
    "点击选择拜访人员": 3416,
    "请输入拜访形式,多个请用空格隔开": 3417,
    "请输入主要成果,多个请用空格隔开": 3418,
    "沟通让工作更高效": 3419,
    "群设置": 3420,
    "设置": 3421,
    "举报": 3422,
    "查询失败，请稍后重试！": 3423,
    "该公告已被{} 于{}年{}月{}日{}时删除！": 3424,
    "超过 20M 的图片请通过文件发送！": 3425,
    "请输入消息": 3426,
    "最多可输入{}个字符": 3427,
    "换行": 3428,
    "自动回复": 3429,
    "超出输入限制！": 3430,
    "Enter发送，Ctrl+Enter换行": 3431,
    "图片处理失败，请重新上传或使用文件方式发送！": 3432,
    "添加自定义": 3433,
    "添加自定义回复": 3434,
    "请输入自定义内容": 3435,
    "消息内容不能为空": 3436,
    "@成员": 3437,
    "截图": 3438,
    "「消息内文件」支持多人编辑啦！！": 3439,
    "上传文件后，点击多人编辑，即可实现多人实时协作，文件实时自动保存，快去试试吧！": 3440,
    "赞": 3441,
    "表情来源：": 3442,
    "屏幕截图": 3443,
    "截图并隐藏系统窗口": 3444,
    "当前已选择文件数": 3445,
    "文件已被撤回": 3446,
    "请输入群名称": 3447,
    "群组名最多输入50个字符": 3448,
    "群组名仅支持输入英文、汉字、数字": 3449,
    "被邀请人通过链接登录/注册后加入项目": 3450,
    "【荣大智慧云】": 3451,
    "“{}”邀请您加入项目“{}”,点击下方链接即可加入": 3452,
    "输入/粘贴手机号，多个可通过换行进行分隔，如": 3453,
    "切换": 3454,
    "目录视图": 3455,
    "个结果,第": 3456,
    "小提示": 3457,
    "如需针对单个目录进行审批操作，可将筛选项中的目录状态选为待审批后点击查询，即可对单个目录进行审批操作": 3458,
    "注：目录审批搜索结果页不会联动选中目录": 3459,
    "主工作台-我的审批-审批记录": 3460,
    "请选择审批人": 3461,
    "审批部门": 3462,
    "请选择审批部门": 3463,
    "请输入审批意见关键字": 3464,
    "节点审批结果": 3465,
    "所在位置": 3466,
    "审批人部门": 3467,
    "当前无选中文件，请选择您要导出的文件": 3468,
    "搜索项目名称{}申请内容": 3469,
    "暂无权限查看该页面": 3470,
    "提醒您尽快审批{}发起的{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}": 3471,
    "新增自然人": 3472,
    "搜索会议主题": 3473,
    "请输入会议类型": 3474,
    "选择导出项": 3475,
    "确定要删除该会议吗？": 3476,
    "删除成功!": 3477,
    "{}会议已被关联，不能删除": 3478,
    "不能删除": 3479,
    "确定删除所有会议？": 3480,
    "已选日志类型": 3481,
    "日志标题（可编辑）": 3482,
    "抄送人（必选）": 3483,
    "项目组成员": 3484,
    "提交日志": 3485,
    "编辑日志": 3486,
    "标题最大长度{}个字": 3487,
    "日志内容不能为空": 3488,
    "日志内容最大长度{}个字": 3489,
    "抄送人不能为空": 3490,
    "提交成功": 3491,
    "发送到人": 3492,
    "搜索日志标题": 3493,
    "与我相关": 3494,
    "我发出的": 3495,
    "暂无日志": 3496,
    "复用这篇日志模板": 3497,
    "分享": 3498,
    "分享这篇日志": 3499,
    "导出附件": 3500,
    "导出到项目文档": 3501,
    "日志修改记录": 3502,
    "暂无修改记录": 3503,
    "新增抄送人": 3504,
    "已经到底啦": 3505,
    "分享日志": 3506,
    "通讯录/我的日志": 3507,
    "工作台/我的日志": 3508,
    "评论{}的日志，可@组织成员，最多可输入{}个字": 3509,
    "确认要把文件放入回删除吗?": 3510,
    "可@组织成员，最多可输入{}个字": 3511,
    "请输入评论内容": 3512,
    "请输入回复内容": 3513,
    "修改日志": 3514,
    "临时草稿自动保存成功": 3515,
    "已自动同步未完成的草稿内容": 3516,
    "确定要引用远程草稿吗？": 3517,
    "检测到您有远程草稿，引用后，将直接使用远程草稿的内容，确定要引用吗？": 3518,
    "创建成功": 3519,
    "抄送人/组织/部门：{} 等{}个无效，已自动移除": 3520,
    "抄送人/组织/部门：{} 无效，已自动移除": 3521,
    "投票截止时间": 3522,
    "我参与的": 3523,
    "起：": 3524,
    "止：": 3525,
    "投票状态": 3526,
    "决策": 3527,
    "项目描述:": 3528,
    "投票编辑": 3529,
    "投票正在进行中不能删除": 3530,
    "确定删除所有选中投票": 3531,
    "请选择要删除选项": 3532,
    "确定删除已勾选投票？": 3533,
    "{}投票已被关联，不能删除": 3534,
    "项目信息（必填）": 3535,
    "（注：项目从属于组织）": 3536,
    "点击选择所属部门": 3537,
    "填写更多内容": 3538,
    "项目信息（选填）": 3539,
    "请输入项目简称": 3540,
    "上级项目": 3541,
    "请输入项目ID搜索": 3542,
    "请选择关联项目": 3543,
    "请选择项目地区": 3544,
    "开始阶段": 3545,
    "请选择开始阶段": 3546,
    "结束阶段": 3547,
    "请先选择业务类型和开始阶段": 3548,
    "请选择结束阶段": 3549,
    "计划开始时间": 3550,
    "计划结束时间": 3551,
    "标签信息（配置）": 3552,
    "引用标签": 3553,
    "完成创建": 3554,
    "温馨提示：": 3555,
    "智慧云用户将直接加入项目": 3556,
    "新用户将收到邀请加入短信": 3557,
    "请选组织名称": 3558,
    "请选择所属部门": 3559,
    "创建商机项目重复，是否继续创建?": 3560,
    "继续": 3561,
    "创建成功！": 3562,
    "新建组织": 3563,
    "填写更多信息（可选）": 3564,
    "智慧云用户将会直接加入项目，新用户将会收到邀请加入短信": 3565,
    "搜索审批流程名称": 3566,
    "新增标签": 3567,
    "字段名称、选项内容不能为空": 3568,
    "标签权限配置": 3569,
    "新增分类": 3570,
    "请输入分类名称（100字以内）": 3571,
    "编辑分类": 3572,
    "删除分类": 3573,
    "标签名称": 3574,
    "标签类型": 3575,
    "选项内容": 3576,
    "分类名称：": 3577,
    "该分类名称已存在，请重新填写": 3578,
    "编辑内容未保存，请保存后再进行其他操作": 3579,
    "该标签信息已被引用，不可删除": 3580,
    "确定要删除该标签分类吗？": 3581,
    "删除后，分类下的标签会一同删除，确定要继续操作吗？": 3582,
    "标签名称：": 3583,
    "请输入标签名称": 3584,
    "标签类型：": 3585,
    "选项内容：": 3586,
    "添加": 3587,
    "新增字段": 3588,
    "删除字段": 3589,
    "文本": 3590,
    "下拉列表": 3591,
    "数值": 3592,
    "不支持的类型": 3593,
    "勾选内容已被引用，不可删除": 3594,
    "输入角色名称进行搜索": 3595,
    "可编辑标签": 3596,
    "选择标签分类": 3597,
    "输入分类名称进行搜索": 3598,
    "已选标签分类": 3599,
    "您删除的内容已被项目应用，删除后不可恢复是否继续": 3600,
    "选择的标签分类不存在，请重新选择！": 3601,
    "当前归档阶段": 3602,
    "历史归档阶段": 3603,
    "当前归档时间": 3604,
    "当前归档人员": 3605,
    "借阅": 3606,
    "借阅人员": 3607,
    "请输入借阅人员": 3608,
    "借阅时长": 3609,
    "借阅内容": 3610,
    "查看全部文件": 3611,
    "确定要取消文件借阅吗？": 3612,
    "已填写的内容尚未提交，当前操作将清空所有内容，确定要继续操作吗？": 3613,
    "提醒您尽快审批关于{}，项目的底稿借阅审批,可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}": 3614,
    "从借阅成功起，借阅时限为{}小时，超过时限后，借阅文件将自动失效": 3615,
    "恢复项目": 3616,
    "恢复项目成功！": 3617,
    "终止原因": 3618,
    "请输入终止原因": 3619,
    "终止时间": 3620,
    "请选择终止日期": 3621,
    "终止说明": 3622,
    "导出组织内您可查看项目的人员信息，以Excel表格格式导出。": 3623,
    "会议发起成功": 3624,
    "是否要将该成员移出项目组？": 3625,
    "(移出项目后，被移出人员所上锁的文件将会解锁)": 3626,
    "加入时间": 3627,
    "邀请人": 3628,
    "已加入{}": 3629,
    "邀请中{}": 3630,
    "申请中{}": 3631,
    "搜索姓名": 3632,
    "角色：": 3633,
    "加入时间：": 3634,
    "离开时间：": 3635,
    "请先选择数据文件": 3636,
    "请选择项目中成员": 3637,
    "成员角色": 3638,
    "角色名称": 3639,
    "编辑角色": 3640,
    "上传文件/新版本": 3641,
    "文件复制": 3642,
    "文件剪切": 3643,
    "文件删除": 3644,
    "文件锁定": 3645,
    "角色名称不能为空": 3646,
    "保存!": 3647,
    "确定要删除该角色吗？": 3648,
    "删除该角色后，添加成员时将无法再选择该角色，确定要继续删除吗？": 3649,
    "修改成功!": 3650,
    "结果": 3651,
    "确定要删除选中的投票结果吗？": 3652,
    "确定删除所有选中投票？": 3653,
    "项目移交": 3654,
    "项目删除": 3655,
    "项目退出": 3656,
    "标签信息": 3657,
    "引用": 3658,
    "选择客户": 3659,
    "导入中": 3660,
    "发行档案": 3661,
    "导入": 3662,
    "下载模板": 3663,
    "发行人联系人": 3664,
    "发行人联系方式": 3665,
    "项目组联系人": 3666,
    "项目组联系方式": 3667,
    "主体资质": 3668,
    "债项资质": 3669,
    "申报规模{}亿{}": 3670,
    "核准规模{}亿{}": 3671,
    "批文有效期": 3672,
    "批复文号": 3673,
    "发行方式": 3674,
    "发行场地": 3675,
    "债券期限": 3676,
    "担保机构": 3677,
    "特殊条款": 3678,
    "往期债券": 3679,
    "承销团成员": 3680,
    "簿记室": 3681,
    "启动发行后填写": 3682,
    "债券简称": 3683,
    "银行间代码": 3684,
    "是否分期": 3685,
    "是否多品种发行": 3686,
    "已发行规模": 3687,
    "交易所代码": 3688,
    "本期债券规模（亿）": 3689,
    "质押代码": 3690,
    "询价利率区间{}%{}": 3691,
    "发行后剩余规模{}亿{}": 3692,
    "最终发行利率{}%{}": 3693,
    "受托期限": 3694,
    "参会委员": 3695,
    "时间类信息": 3696,
    "添加时间字段": 3697,
    "已被任务引用，不可编辑": 3698,
    "发行成功后填写": 3699,
    "是否为受托管理人": 3700,
    "抄送方式{}审批通过后通知": 3701,
    "请输入申请内容{}最多输入200字": 3702,
    "人员选择": 3703,
    "请输入登录密码": 3704,
    "移交创建人角色": 3705,
    "移交后退出项目并解锁上锁文件": 3706,
    "任务移交至新设创建人": 3707,
    "当前项目": 3708,
    "点击退出项目后，由您上锁的文件将会自动解锁": 3709,
    "请确认登录密码": 3710,
    "退出": 3711,
    "是否确认删除该项目": 3712,
    "利益冲突核查报告列表": 3713,
    "查看报告": 3714,
    "利益冲突比对结果报告": 3715,
    "项目发行信息档案导入": 3716,
    "共{}个导入项，其中{}个可成功导入": 3717,
    "发现以下{}个导入项不符合导入要求，将不会被导入": 3718,
    "导入项": 3719,
    "错误原因": 3720,
    "确定导入": 3721,
    "确定要导入发行档案信息吗": 3722,
    "导入信息后，当前信息将会被覆盖，确定要继续导入吗？": 3723,
    "赵达": 3724,
    "您没有权限查看该项目信息": 3725,
    "项目编码不能为空": 3726,
    "项目名称不能为空": 3727,
    "结束日期不能早于开始日期": 3728,
    "所属部门不能为空": 3729,
    "确定要删除项目吗?": 3730,
    "项目删除成功！": 3731,
    "密码错误": 3732,
    "移交创建人角色不能为空": 3733,
    "您当前为项目创建人，请先移交项目": 3734,
    "该成员不在项目中": 3735,
    "当前无审批通过的底稿文件可归档": 3736,
    "确定要选择客户吗？": 3737,
    "选择客户后将无法进行变更，确定继续操作吗？": 3738,
    "银行间代码不能超出20位数字，请修改。": 3739,
    "交易所代码不能超出20位数字，请修改。": 3740,
    "质押代码不能超出20位数字，请修改。": 3741,
    "询价利率区间格式不正确，请修改。": 3742,
    "批文有效期开始时间不能大于结束时间": 3743,
    "不能存在相同的时间字段，请修改": 3744,
    "文件类型不匹配": 3745,
    "请选择时间变量": 3746,
    "剩余一个时间变量项时不可删除": 3747,
    "以内的Excel导入(xls,xlsx)；": 3748,
    "第一列": 3749,
    "为任务标题，不能超过180字；": 3750,
    "单次": 3751,
    "最高支持导入": 3752,
    "条数据，超过 1000条的部分忽略不计；": 3753,
    "导入任务均为一级任务，不展示父子任务关系。": 3754,
    "导入任务": 3755,
    "正在识别中，请稍后...": 3756,
    "请选择导入阶段:": 3757,
    "可导入{}个，识别失败{}个": 3758,
    "注:1.如未处理识别失败的任务，失败任务将不会建立；2.如操作栏下关闭的任务将不会建立。": 3759,
    "创建任务": 3760,
    "上一个失败任务": 3761,
    "下一个失败任务": 3762,
    "未识别到任务名称，请检查本地文件": 3763,
    "请上传 4M 以内的Excel文件（xls、xlsx）。": 3764,
    "任务建立失败，请在操作栏下开启任务": 3765,
    "建立任务成功": 3766,
    "是否取消建立任务，确认后将不会建立任务。": 3767,
    "查看更多父级": 3768,
    "所属任务": 3769,
    "确定要删除该条消息吗？": 3770,
    "通知发行人或客户（适用于外部人员）": 3771,
    "请输入子任务名称，按回车键完成": 3772,
    "请输入子任务名称": 3773,
    "编辑任务": 3774,
    "收起设置": 3775,
    "任务设置": 3776,
    "新建任务": 3777,
    "当前内容已变更，是否保存修改？": 3778,
    "最大可同时打开10个任务选项卡，是否关闭其他选项卡": 3779,
    "注意事项": 3780,
    "请输入任务标题（必填）": 3781,
    "任务内容": 3782,
    "任务产出": 3783,
    "工时统计": 3784,
    "任务动态": 3785,
    "文件会上传到任务产出中": 3786,
    "任务完成": 3787,
    "请输入任务标题": 3788,
    "任务基本信息未保存，请保存后继续该操作": 3789,
    "确定要{}任务": 3790,
    "有项目时间信息不完整，是否完善?": 3791,
    "全部动态": 3792,
    "日常沟通({})": 3793,
    "任务日志": 3794,
    "正式回复({})": 3795,
    "不能重复选择": 3796,
    "搜索添加执行人": 3797,
    "搜索添加抄送人": 3798,
    "添加任务标签": 3799,
    "请选择时间变量（仅对债类业务有效）": 3800,
    "任务提醒": 3801,
    "请选择自定义时间": 3802,
    "每个月第{}天": 3803,
    "每个{}月第{}天": 3804,
    "每个月第{}个星期{}": 3805,
    "每个{}月第{}个星期{}": 3806,
    "每年{}": 3807,
    "每{}年": 3808,
    "到": 3809,
    "重复{}次": 3810,
    "每月第{}个": 3811,
    "每年{}{}日": 3812,
    "每周星期{}": 3813,
    "每月第{}星期{}": 3814,
    "每年{}日": 3815,
    "每{}天": 3816,
    "星期{}": 3817,
    "每周{}": 3818,
    "每{}周{}": 3819,
    "每月第{}天": 3820,
    "每{}月第{}天": 3821,
    "每月第x天": 3822,
    "每{}月第x天": 3823,
    "每月第{}个星期{}": 3824,
    "每{}月第{}个星期{}": 3825,
    "每月第x个星期第x天": 3826,
    "每{}月第x个星期第x天": 3827,
    "请输入内容，可@任务成员，最多可输入{}字": 3828,
    "超出{}字输入限制": 3829,
    "自定义周期": 3830,
    "重复频率": 3831,
    "重复时间": 3832,
    "无限重复": 3833,
    "终止于某天": 3834,
    "选择日期时间": 3835,
    "限定重复次数": 3836,
    "次后": 3837,
    "天": 3838,
    "个月": 3839,
    "请选择重复时间": 3840,
    "每{}天到{}结束": 3841,
    "每{}天，重复{}次": 3842,
    "星期{},": 3843,
    "每{}周的{}": 3844,
    "每{}周的{}{}结束": 3845,
    "每{}周的{}，重复{}次": 3846,
    "每{}月的第{}天": 3847,
    "每{}月的第{}天到{}结束": 3848,
    "每{}月的第{}天,重复{}次": 3849,
    "每{}月": 3850,
    "到{}结束": 3851,
    "每{}年,重复{}次": 3852,
    "完成任务": 3853,
    "完成任务(所有人)": 3854,
    "取消完成(所有人)": 3855,
    "你修改了任务名称，是否同步修改任务文件夹名称？": 3856,
    "文件夹名称重复时，自动重命名": 3857,
    "文件夹名称重复时，中止保存": 3858,
    "设置计划工时": 3859,
    "填报实际工时": 3860,
    "计划任务工时": 3861,
    "实际任务工时": 3862,
    "禁止更新他人工时": 3863,
    "计划工时/小时": 3864,
    "实际工时/小时": 3865,
    "填写本次新增工时": 3866,
    "将离开工时统计页面，已填写工时尚未保存，是否保存修改？": 3867,
    "不保存": 3868,
    "工时调整不可超过当前实际工时": 3869,
    "选择导入任务": 3870,
    "当前业务类型下的模板": 3871,
    "已选任务数量:": 3872,
    "确认导入": 3873,
    "该业务类型未配置任务模板": 3874,
    "请尝试以下两种操作": 3875,
    "导入Excel模板": 3876,
    "前往配置任务模板": 3877,
    "请联系管理员为该业务类型配置任务模板": 3878,
    "请先选择任务": 3879,
    "弹窗关闭": 3880,
    "暂无相关任务数据": 3881,
    "未添加执行人": 3882,
    "未添加抄送人": 3883,
    "未选择时间": 3884,
    "未添加标签": 3885,
    "未填写无任务内容": 3886,
    "未填写注意事项": 3887,
    "正式回复": 3888,
    "查看全部回复内容": 3889,
    "正在加载中......": 3890,
    "任务产出-文件": 3891,
    "暂不支持在浏览器中下载文件夹，请通过PC客户端下载": 3892,
    "确定要取消关联吗？": 3893,
    "取消关联后，该文件将从「任务产出」中移除，确定要取消关联码？": 3894,
    "取消关联成功": 3895,
    "全部完成": 3896,
    "批量编辑任务": 3897,
    "自定义时间": 3898,
    "重复周期": 3899,
    "添加子任务": 3900,
    "每年{}月{}日": 3901,
    "每{}年{}": 3902,
    "是否打开": 3903,
    "是否继续?": 3904,
    "已取消关闭": 3905,
    "请填写完整的时间": 3906,
    "是否保存任务基本信息并继续当前操作？是否继续?": 3907,
    "请输入任务名称": 3908,
    "确定要删除该{}吗, 是否继续?": 3909,
    "取消输入": 3910,
    "确定要关闭该{}吗, 是否继续?": 3911,
    "确定要删除该任务吗, 是否继续?": 3912,
    "确定要关闭该任务吗, 是否继续?": 3913,
    "关闭成功!": 3914,
    "全部编辑成功": 3915,
    "{}个任务编辑成功，{}个任务编辑失败": 3916,
    "可拖拽文件上传": 3917,
    "选中的文件取消关联后，将从「参考文件」中移除，确定要取消关联吗？": 3918,
    "取消关联后，该文件将从「参考文件」中移除，确定要取消关联吗？": 3919,
    "选择阶段导入": 3920,
    "新模板以增量的方式覆盖之前的模板, 是否继续?": 3921,
    "任务模板预览": 3922,
    "确认配置": 3923,
    "新导入任务“更新《{}》”与原有模板任务重名！": 3924,
    "新导入任务“更新": 3925,
    "”与原有模板任务重名！": 3926,
    "自动重命名": 3927,
    "跳过这个任务": 3928,
    "后续同名任务是否按此规则执行": 3929,
    "添加调查工具": 3930,
    "新增调查工具": 3931,
    "工具链接": 3932,
    "编辑调查工具": 3933,
    "确定要删除吗？": 3934,
    "已有标签": 3935,
    "暂无标签": 3936,
    "标签字数不超过{}个字，按回车保存": 3937,
    "选择标签颜色": 3938,
    "请给标签选择一个颜色": 3939,
    "修改记录": 3940,
    "请输入标签,标签字数不超过{}个字，按回车保存": 3941,
    "请输入标签,标签字数不超过{}个字": 3942,
    "任务数量": 3943,
    "包含不可见任务": 3944,
    "个任务": 3945,
    "最新修改人": 3946,
    "最新修改时间": 3947,
    "确定要删除该标签吗？": 3948,
    "标签被删除后，任务中引用的该标签将同时被删除，确定要继续删除吗？": 3949,
    "标签修改记录": 3950,
    "操作内容": 3951,
    "将本列表所有任务删除": 3952,
    "取消完成任务": 3953,
    "所属父任务": 3954,
    "确定要删除任务{}": 3955,
    "批量操作": 3956,
    "添加任务": 3957,
    "确定要{}所有选中的任务吗？": 3958,
    "已打开的任务": 3959,
    "关闭所有任务": 3960,
    "显示侧边栏": 3961,
    "自定义侧边栏": 3962,
    "对扩展工具栏是否满意": 3963,
    "感谢你的反馈": 3964,
    "发送反馈": 3965,
    "请告诉我们不满意的原因": 3966,
    "请对您的问题类型进行详细描述": 3967,
    "好的，感谢你的反馈！我们将尽快做出优化计划": 3968,
    "是什么原因": 3969,
    "请输入{}名称": 3970,
    "修改日期": 3971,
    "输入要搜索的目录": 3972,
    "目录名称": 3973,
    "增加子目录": 3974,
    "子目录名称": 3975,
    "请输入目录名称": 3976,
    "删除后，将删除该目录下的所有子目录,是否确认删除？": 3977,
    "请输入注意事项,最多输入200字": 3978,
    "输入内容不能为空": 3979,
    "目录列表": 3980,
    "搜索目录名称": 3981,
    "下载目录模板": 3982,
    "新增目录": 3983,
    "权限设置": 3984,
    "权限配置": 3985,
    "目录名称：": 3986,
    "所属业务类型：": 3987,
    "备注信息：": 3988,
    "请输入备注信息": 3989,
    "目录文件：": 3990,
    "注：1、请上传纯目录的word文件或符合要求的excel文件，上传目录文件后，系统将自动解析生产目录；": 3991,
    "2、如果您的目录模板含有特殊字符，引用前台时系统会自动帮您替换为空格或下划线；": 3992,
    "请先选择数据": 3993,
    "请先复制目录": 3994,
    "仅含项目阶段的业务类型可进行粘贴": 3995,
    "目录支持上传以下格式的文件：DOC、DOCX、XLS、XLSX，请重新上传正确格式的文件后重试": 3996,
    "该文件中未检测到目录信息": 3997,
    "操作过于频繁": 3998,
    "请上传纯目录的word文件或符合要求的excel文件": 3999,
    "已设置窗口正常大小": 4000,
    "已设置窗口最大化": 4001,
    "多窗体模式已开启": 4002,
    "当打开了一个或多个独立窗体时，你可以将不同项目之间的任何文件进行自由拖动": 4003,
    "提示：": 4004,
    "从当前项目文档或底稿视图向不同项目的窗体拖动文件时，操作结果做复制粘贴处理": 4005,
    "在开启消息独立窗口时，可以将当前列表中的文件直接拖拽至会话中": 4006,
    "数据权限范围": 4007,
    "组织内成员": 4008,
    "已选部门/成员": 4009,
    "所在部门成员个人日志": 4010,
    "指定部门/成员个人日志": 4011,
    "组织全部成员个人日志": 4012,
    "下列部门/成员不存在，已从「已选列表」中自动移除": 4013,
    "审批类型名称": 4014,
    "类型名称": 4015,
    "荣大科技": 4016,
    "是否确定删除？": 4017,
    "已经是第一条": 4018,
    "已经最后第一条": 4019,
    "请填写审批类型名称": 4020,
    "{}该审批类型，将同步{}该审批类型下的所有流程, 是否继续?": 4021,
    "添加配置": 4022,
    "借阅权限": 4023,
    "请输入时间": 4024,
    "当前时间不能删除": 4025,
    "借阅时间未配置，请进行配置": 4026,
    "时间不能为空": 4027,
    "当前输入的时间已存在": 4028,
    "添加类型": 4029,
    "会议类型配置": 4030,
    "投票类型配置": 4031,
    "请输入类型名称": 4032,
    "人数限制": 4033,
    "人员限制": 4034,
    "类型说明": 4035,
    "人,": 4036,
    "投票规则": 4037,
    "大于等于": 4038,
    "人同意允许通过": 4039,
    "人有条件通过为有条件通过": 4040,
    "人不同意不通过": 4041,
    "人暂缓表决为暂缓表决": 4042,
    "请输入人数": 4043,
    "人参加才能发起": 4044,
    "添加限制人员": 4045,
    "请输入类型说明": 4046,
    "同意（必选）": 4047,
    "不同意（必选）": 4048,
    "的人": 4049,
    "注：有条件通过默认为通过暂缓表决默认为不通过": 4050,
    "例：（2/3）的人大于等于同意允许通过": 4051,
    "例：有条件通过允许通过": 4052,
    "例：不同意为不通过": 4053,
    "例：暂缓表决为不通过": 4054,
    "例：（2/3）有条件通过允许通过": 4055,
    "例：（2/3）不同意为不通过": 4056,
    "例：（2/3）暂缓表决为不通过": 4057,
    "该角色已存在": 4058,
    "会议类型名称不能为空": 4059,
    "人员限制不能为空": 4060,
    "人数限制小于人员限制人数总和": 4061,
    "确定删除所选会议": 4062,
    "投票类型名称不能为空": 4063,
    "人数限制不能为空": 4064,
    "投票规则值不能为空": 4065,
    "投票规则最大值不能小于最小值": 4066,
    "确定删除所选投票": 4067,
    "通知方式配置": 4068,
    "短信通知": 4069,
    "启用短信通知": 4070,
    "注：启用前请确保系统已调试成功。": 4071,
    "邮件通知": 4072,
    "启用邮件通知": 4073,
    "保存失败": 4074,
    "获取失败": 4075,
    "业务类型名称": 4076,
    "退出编辑": 4077,
    "下载模版": 4078,
    "项目阶段名称": 4079,
    "请输入类型名称（50字以内）": 4080,
    "确定要导入业务类型吗?": 4081,
    "只能导入xls、xlsx格式文件": 4082,
    "导入成功！": 4083,
    "{}个阶段导入失败，阶段名称不可重复。": 4084,
    "{}个阶段导入失败，阶段名称不支持输入特殊字符。": 4085,
    "请填写阶段名称": 4086,
    "暂无数据可编辑": 4087,
    "成功修改": 4088,
    "{}该业务类型，将同步{}该业务类型下的所有流程和模板, 是否继续?": 4089,
    "角色基本信息": 4090,
    "修改项目角色": 4091,
    "选中角色已复制，请选择需要粘贴的角色": 4092,
    "确定删除选中的角色": 4093,
    "任务配置搜索结果": 4094,
    "新增任务模板": 4095,
    "模板名称": 4096,
    "包含以下全部关键字{}以空格区分{}": 4097,
    "请选择创建人": 4098,
    "新建任务模板": 4099,
    "任务模板名称": 4100,
    "注：如果您的任务模板含有特殊字符情况，引用前台时系统会自动帮您替换为空格或下划线处理；": 4101,
    "项目阶段类型": 4102,
    "任务模板名称：": 4103,
    "选择业务类型：": 4104,
    "请输入任务模板名称": 4105,
    "存在同名模板是否确定继续保存": 4106,
    "编辑任务模板": 4107,
    "此操作将永久删除该模板, 是否继续?": 4108,
    "任务导出": 4109,
    "是否保存已编辑内容": 4110,
    "暂无模板导出": 4111,
    "{}, 是否继续?": 4112,
    "导入后的阶段任务模板将会覆盖当前阶段模板，是否导入?": 4113,
    "请导入从系统中下载的模板！": 4114,
    "此操作将永久删除该任务, 是否继续?": 4115,
    "时间变量名称": 4116,
    "请输入时间变量名称": 4117,
    "查询结果为空": 4118,
    "添加时间变量": 4119,
    "编辑时间变量": 4120,
    "请先将时间规则禁用后删除": 4121,
    "是否要删除?": 4122,
    "启用成功！": 4123,
    "新增配置": 4124,
    "暂无权限查看，如有需要请联系组织管理员": 4125,
    "规则名称": 4126,
    "包含以下关键字": 4127,
    "IP地址": 4128,
    "受控人员": 4129,
    "请输入人员姓名": 4130,
    "请选择操作用户": 4131,
    "IP安全配置": 4132,
    "公网IP地址": 4133,
    "受控人数": 4134,
    "停用": 4135,
    "人员编辑": 4136,
    "IP编辑": 4137,
    "IP监控日志": 4138,
    "您确定删除该IP吗?": 4139,
    "字段管理": 4140,
    "注：关闭后，该字段在表单中将取消必填。": 4141,
    "文件解锁信息": 4142,
    "于{}手动解锁{}项文件": 4143,
    "锁定信息": 4144,
    "于": 4145,
    "进行编辑": 4146,
    "试用申请已提交成功，专员将在2个工作日内联系您": 4147,
    "智能网查将在5-10分钟内自动开通，请注意查收短信或智慧云消息": 4148,
    "分享有礼": 4149,
    "二维码邀请": 4150,
    "活动规则": 4151,
    "同一手机号视为同一用户，不重复赠送活动奖品": 4152,
    "邀请好友成功后，系统会自动发放奖品到您的账户中，请注意查收。": 4153,
    "活动时间": 4154,
    "权益有效期：自权益开通之日起{}内有效，过期作废，不予补偿。": 4155,
    "一旦发现有人邀请数据作弊，将清除其邀请数据，取消其获奖资格。": 4156,
    "还没有邀请成功的好友哦~": 4157,
    "奖励": 4158,
    "二维码复制失败，将下载该图片": 4159,
    "邀请二维码": 4160,
    "请输入联系人姓名": 4161,
    "人员属性": 4162,
    "请选择人员属性": 4163,
    "新增客户联系人": 4164,
    "固话": 4165,
    "身份证号": 4166,
    "是否为董监高": 4167,
    "新建联系人": 4168,
    "部门：": 4169,
    "请输入固话": 4170,
    "请输入职务": 4171,
    "证件号码": 4172,
    "请输入证件号码": 4173,
    "请输入手机号码": 4174,
    "编辑客户联系人": 4175,
    "确定删除该联系人": 4176,
    "全部人员": 4177,
    "董监高": 4178,
    "联系人名称内容不能为空": 4179,
    "部门内容不能为空": 4180,
    "固定电话内容不能为空": 4181,
    "固定电话仅支持\"-\"和数字，长度为{}字。": 4182,
    "是否为董监高为必选": 4183,
    "证件号码格式不正确,请重新输入": 4184,
    "职务内容不能为空": 4185,
    "手机号码内容不能为空": 4186,
    "手机号格式不正确,请重新输入": 4187,
    "邮箱格式不正确,请重新输入": 4188,
    "固定电话不能为空": 4189,
    "证件号码错误": 4190,
    "手机号码不能为空": 4191,
    "手机号码有误，请重填": 4192,
    "请选择客户地区": 4193,
    "服务团队": 4194,
    "信息跟踪人": 4195,
    "请输入信息跟踪人": 4196,
    "资本注册": 4197,
    "张三": 4198,
    "请输入正确格式": 4199,
    "客户中文名": 4200,
    "客户英文名": 4201,
    "客户国籍": 4202,
    "客户性别": 4203,
    "出生日期": 4204,
    "身份证号码": 4205,
    "请输入身份证号": 4206,
    "客户出生日期内容不能为空": 4207,
    "股东名称": 4208,
    "请输入股东名称": 4209,
    "股东类型": 4210,
    "请选择股东类型": 4211,
    "新增股东信息": 4212,
    "持股数": 4213,
    "持股比例": 4214,
    "身份证号/信用代码": 4215,
    "股东姓名": 4216,
    "请输入股东姓名": 4217,
    "持股数量": 4218,
    "请输入持股数": 4219,
    "信用代码": 4220,
    "请输入统一社会信用代码": 4221,
    "请输入持股比例": 4222,
    "编辑股东信息": 4223,
    "变更记录": 4224,
    "股东": 4225,
    "变更前股权比例": 4226,
    "变更后股权比例": 4227,
    "股权变更日期": 4228,
    "身份证号：": 4229,
    "信用代码：": 4230,
    "股东类型内容不能为空": 4231,
    "股东姓名内容不能为空": 4232,
    "持股数量内容不能为空": 4233,
    "身份证号/统一社会信用代码不能为空": 4234,
    "身份证号错误": 4235,
    "持股比例内容不能为空": 4236,
    "请输入拜访人员": 4237,
    "新增拜访记录": 4238,
    "新建拜访记录": 4239,
    "拜访记录信息": 4240,
    "拜访创建人": 4241,
    "请输入拜访形式": 4242,
    "请输入拜访地点": 4243,
    "请输入主要成果": 4244,
    "保 存": 4245,
    "编辑拜访记录": 4246,
    "确定删除该拜访记录吗": 4247,
    "拜访创建人内容不能为空": 4248,
    "拜访人员内容不能为空": 4249,
    "拜访开始日期内容不能为空": 4250,
    "拜访结束日期内容不能为空": 4251,
    "拜访地点内容不能为空": 4252,
    "主要成果内容不能为空": 4253,
    "结束时间不能小于开始时间": 4254,
    "暂不支持使用": 4255,
    "此应用当前仅支持智慧云Windows客户端使用，请先下载客户端": 4256,
    "项目创建时间": 4257,
    "新建{}": 4258,
    "请选择要下载的文件": 4259,
    "文件夹不支持下载，请选择下载文件": 4260,
    "文件夹不支持版本查看": 4261,
    "请选择要删除的数据": 4262,
    "已有相同名称的文件夹，是否以 {} 命名文件夹": 4263,
    "该文件已解锁": 4264,
    "文件回收站": 4265,
    "请选择要还原的文件": 4266,
    "已经到根目录了": 4267,
    "还原路径": 4268,
    "部分对象的还原路径不存在，请选择还原路径": 4269,
    "共{}个结果, 第{}个": 4270,
    "不能包含特殊字符\\\\/:*?\"<>|": 4271,
    "已有相同名称的目录，是否以 {} 命名目录": 4272,
    "已取消重命名": 4273,
    "今天也辛苦啦": 4274,
    "智慧云陪你一起努力": 4275,
    "历史沟通记录": 4276,
    "进入组织": 4277,
    "已同意": 4278,
    "立即沟通": 4279,
    "好的，现在创建": 4280,
    "进入群聊": 4281,
    "定位到文件": 4282,
    "文件创建失败": 4283,
    "定位到文件夹": 4284,
    "欢迎来到智慧云！": 4285,
    "已拒绝": 4286,
    "立即评价": 4287,
    "查看订单": 4288,
    "支付订单": 4289,
    "去处理": 4290,
    "去审批": 4291,
    "已评价": 4292,
    "请到主窗口操作此功能!": 4293,
    "已失效": 4294,
    "你不在当前项目中，暂不能查看项目信息": 4295,
    "输入关键词进行搜索": 4296,
    "关键词": 4297,
    "请输入关键词进行搜索(空格区分)": 4298,
    "可操作": 4299,
    "消息类型": 4300,
    "点击选择消息类型": 4301,
    "没有与搜索结果的匹配项，请检查你的搜索选项": 4302,
    "群成员": 4303,
    "以下所有人": 4304,
    "编辑群公告": 4305,
    "设为置顶": 4306,
    "删除群公告": 4307,
    "群公告置顶成功！": 4308,
    "操作失败，请稍后再试！": 4309,
    "确定要删除该篇公告吗？": 4310,
    "群公告删除成功！": 4311,
    "新建群公告": 4312,
    "超出输入限制": 4313,
    "若要插入链接，请以：http:// 或者 https:// 开头": 4314,
    "超出最大字符长度，请检查！": 4315,
    "群公告更新成功！": 4316,
    "群公告创建成功！": 4317,
    "确定要离开当前页面吗？": 4318,
    "已输入的内容尚未发布，当前操作将清空所有内容，确定要继续操作吗？": 4319,
    "设为": 4320,
    "没有更多啦": 4321,
    "暂无群公告": 4322,
    "群公告适用于发布群规、活动等信息": 4323,
    "更新于": 4324,
    "对方已注销账号": 4325,
    "发送消息": 4326,
    "机器人": 4327,
    "@消息": 4328,
    "选择群成员": 4329,
    "无可下载文件": 4330,
    "暂无聊天记录": 4331,
    "未找到相关记录": 4332,
    "下载全部": 4333,
    "讨论文件合集{}项": 4334,
    "[该消息类型本版本暂不支持查看（如需了解消息内容，请直接联系发送人）]": 4335,
    "您已被踢出此群聊": 4336,
    "文件不存在": 4337,
    "您已退出当前会话群，无法继续访问！": 4338,
    "讨论文件合集中所有文件版本/文件夹内容将实时与文档中内容进行同步更新": 4339,
    "选中另存为": 4340,
    "全部另存为": 4341,
    "选中下载": 4342,
    "全部下载": 4343,
    "该文件类型暂不支持预览，是否下载到本地？": 4344,
    "讨论文件合集已被撤回": 4345,
    "项目/群名称": 4346,
    "归属组织": 4347,
    "新建项目群已提交审批！": 4348,
    "确认提取聊天记录的归属组织": 4349,
    "选择归属组织": 4350,
    "选择组织": 4351,
    "请选择组织": 4352,
    "选择订单": 4353,
    "请选择订单": 4354,
    "提取成功!": 4355,
    "支持 “多个文件” 另存为啦！！": 4356,
    "选择多个文件，点击另存为即可实现多文件一起另存至同 一路径下（讨论文件合集暂不支持多选另存）": 4357,
    "逐条转发": 4358,
    "合并转发": 4359,
    "文件另存为": 4360,
    "提取聊天记录": 4361,
    "解散该群后，所有群成员将失去和群内成员的联系，同时该群的聊天图片、文件也将被删除！": 4362,
    "退出后，不会再接收此群聊消息！": 4363,
    "移除后，{}将无法收到该群聊的消息!": 4364,
    "解散群聊": 4365,
    "退出群聊": 4366,
    "移除群成员": 4367,
    "您不是群主，没有权限修改": 4368,
    "修改群信息成功": 4369,
    "备注名(仅自己可见)": 4370,
    "置顶聊天": 4371,
    "转让群主": 4372,
    "手机或邮箱邀请": 4373,
    "您已重复添加此内容！": 4374,
    "已邀请加入群聊": 4375,
    "邀请": 4376,
    "邀请群成员": 4377,
    "所要加入群聊": 4378,
    "分享群链接或群二维码，成员可快速加入群聊，快来试试吧！": 4379,
    "【荣大智慧云】“{}”邀请您加入讨论组“{}”，点击下方链接即可加入。": 4380,
    "被邀请人通过链接登录/注册后加入群聊": 4381,
    "【荣大智慧云】“{}”邀请您加入讨论组“{}”, 点击下方链接即可加入": 4382,
    "群主": 4383,
    "获取群成员信息失败": 4384,
    "群成员列表": 4385,
    "转让群主-选择成员": 4386,
    "选择超出限制": 4387,
    "讨论组邀请": 4388,
    "项目邀请": 4389,
    "组织邀请": 4390,
    "荣大智慧云外链分享的文件，请查看": 4391,
    "【荣大智慧云】“{}”邀请您加入“{}”，点击链接立即申请加入吧！用荣大智慧云开启高效协作模式。": 4392,
    "【荣大智慧云】“{}”邀请您加入项目“{}”，点击下方链接即可加入": 4393,
    "组织加入成功": 4394,
    "非项目成员无此功能权限": 4395,
    "你可以联系项目创建人索取项目编码，申请加入对应的项目。": 4396,
    "也可以由此项目负责人邀请您加入项目。": 4397,
    "去联系项目创建人": 4398,
    "源文件已不存在，无法操作此项": 4399,
    "源文件所在位置": 4400,
    "查看来源位置": 4401,
    "没有匹配到任何结果": 4402,
    "选择已达上限": 4403,
    "你有新消息": 4404,
    "回到底部": 4405,
    "加载更多": 4406,
    "我的群组": 4407,
    "暂无评论...": 4408,
    "日志详情": 4409,
    "最近会话": 4410,
    "给对方留言（字数限制{}字）": 4411,
    "超过选择限制，不能选择": 4412,
    "没有找到关于“{}”的结果": 4413,
    "请选择开通权益的组织": 4414,
    "（仅支持自己创建的组织）": 4415,
    "您还没有自己创建的组织，无法匹配权益，请先创建自己的组织": 4416,
    "立即开通": 4417,
    "文件上传进度": 4418,
    "文件未全部上传，是否关闭界面并清空上传列表?": 4419,
    "({}人)": 4420,
    "请添加成员": 4421,
    "创建群聊成功": 4422,
    "添加成员成功": 4423,
    "在这里通过「复用已有日志」进行新建": 4424,
    "输入评论 (Enter 发送)，支持@组织内成员": 4425,
    "输入文字超出最长限制": 4426,
    "邀请链接：": 4427,
    "返回列表": 4428,
    "点击选择会计师事务所": 4429,
    "点击选择律师事务所": 4430,
    "点击选择资产评估机构": 4431,
    "点击选择信用评级机构": 4432,
    "点击选择券商机构": 4433,
    "请选择客户名称": 4434,
    "请输入主营业务": 4435,
    "输入五字以上进行模糊搜索": 4436,
    "未选择": 4437,
    "未配置**": 4438,
    "请填写必填项": 4439,
    "关联内容": 4440,
    "请输入搜索内容": 4441,
    "完 成": 4442,
    "项目底稿": 4443,
    "下载选中": 4444,
    "上传文件到此目录下": 4445,
    "当前目录下禁止拖拽上传": 4446,
    "今天的任务": 4447,
    "未完成任务": 4448,
    "任务前置": 4449,
    "当前任务[{}], 是否依赖审批结果?": 4450,
    "当前任务[{}], 是否取消依赖批结果?": 4451,
    "取消关联后，该文件将从「任务产出」中移除，确定要取消关联吗？": 4452,
    "选中的文件取消关联后，将从「任务产出」中移除，确定要取消关联吗？": 4453,
    "是否依赖此关联任务": 4454,
    "是否取消依赖此任务": 4455,
    "当前任务[{}], {}?": 4456,
    "关闭本次": 4457,
    "不再查看": 4458,
    "了解全部权益": 4459,
    "日志模板": 4460,
    "发布模板": 4461,
    "创建模板": 4462,
    "子任务": 4463,
    "是否删除{}子任务": 4464,
    "所有动态": 4465,
    "是否删除": 4466,
    "日志类型状态内容不能为空": 4467,
    "是否要删除": 4468,
    "任务模板编辑": 4469,
    "每{}月的第{}": 4470,
    "每{}月的第{}到{}结束": 4471,
    "每{}月的第{},重复{}次": 4472,
    "{}到{}": 4473,
    "{},重复{}次": 4474,
    "图片不允许再次发送": 4475,
    "文件不允许再次发送": 4476,
    "视频不允许再次发送": 4477,
    "音频不允许再次发送": 4478,
    "注：最多导入200行，不含表头，格式同下表": 4479,
    "注：荣大服务人员不会占用席位": 4480,
    "总计": 4481,
    "剩余可用席位:": 4482,
    "席位扩容": 4483,
    "Excel导入": 4484,
    "全部清空": 4485,
    "新增一行": 4486,
    "新增十行": 4487,
    "单次最多添加{}人，现已满{}人，不可添加。": 4488,
    "未识别到人员信息，请检查本地文件!": 4489,
    "添加模板内容": 4490,
    "下拉": 4491,
    "标题不能为空，请输入标题": 4492,
    "必填": 4493,
    "非必填": 4494,
    "单选": 4495,
    "选项": 4496,
    "请输入选项内容": 4497,
    "添加选项": 4498,
    "请输入选项内容，最多{}字": 4499,
    "输入不能超过{}字": 4500,
    "请输入标题，最多{}字": 4501,
    "使用此模板时默认抄送人不可被移除": 4502,
    "模板标题（必填）": 4503,
    "模板标题不能为空，请输入模板标题": 4504,
    "请输入模板标题，最多{}字": 4505,
    "需填写者输入内容": 4506,
    "编辑IP配置，配置人员在登录组织时，需要受控的IP环境下才能登录组织": 4507,
    "第一步：设置受控的公网IP地址（共两步）": 4508,
    "请输入规则名称": 4509,
    "IP 地址": 4510,
    "IP 说明：": 4511,
    "编辑后默认启用": 4512,
    "创建后默认启用": 4513,
    "保存进入下一步": 4514,
    "未输入规则名称": 4515,
    "未输入正确 IP 地址": 4516,
    "IP白名单地址已存在": 4517,
    "操作失败，请稍后再试": 4518,
    "您确认关闭弹窗吗? 点击 \"确定\" 将不会保留数据": 4519,
    "编辑受控人员，该人员在登录组织时，需要受控的IP环境下才能登录组织": 4520,
    "第二步：选择受控人员，该人员在登录组织时，需要在第一步受控的IP环境下才能登录组织": 4521,
    "搜索人员名称": 4522,
    "人员展示区": 4523,
    "手机号(必填)": 4524,
    "工作单位": 4525,
    "注：组织信息中，组织归属人不受组织安全规则配置限制": 4526,
    "是否清除所有人员?": 4527,
    "编辑 IP 配置": 4528,
    "编辑人员配置": 4529,
    "提交的举报暂不支持取消或者撤回，举报理由请您如实客观选择": 4530,
    "请选择举报理由": 4531,
    "补充描述": 4532,
    "请输入 {} 字以内的描述": 4533,
    "补充描述不能为空": 4534,
    "上传图片证据": 4535,
    "图片证据如：聊天截图或其它证明材料": 4536,
    "图片数量已超过 {} 张，不能再继续上传": 4537,
    "最少需要上传一张图片": 4538,
    "图片数量最大不能超过 {} 张": 4539,
    "图片列表": 4540,
    "违反国家法律法规": 4541,
    "未获得权利人的合法授权": 4542,
    "泄露商业机密": 4543,
    "侵犯个人隐私": 4544,
    "垃圾信息骚扰": 4545,
    "涉及未成年人有害信息（涉及未成年人有害信息举报专区）": 4546,
    "提交失败，信息不能为空": 4547,
    "您已举报成功，管理员将会在后台进行处理": 4548,
    "当前上传图片已超过最大限制，最多上传 {} 张图片": 4549,
    "消息接收人列表": 4550,
    "人已读": 4551,
    "已收听": 4552,
    "选择的消息为特殊类型消息，暂不支持转发": 4553,
    "选择的消息中，{}等特殊类型的消息暂不支持转发": 4554,
    "语音消息、群公告、聊天记录、任务消息、讨论文件合集等特殊类型的消息暂不支持转发": 4555,
    "继续转发": 4556,
    "转发后不显示内容": 4557,
    "消息转发": 4558,
    "转发成功": 4559,
    "单次短信加急可选5人，超过后默认以站内信方式进行发送": 4560,
    "短信接收人": 4561,
    "仅应用内 加急": 4562,
    "应用内+短信 加急": 4563,
    "公司名称": 4564,
    "人已收听": 4565,
    "全部已收听": 4566,
    "{}人执行": 4567,
    "（已选中{}项，共{}项）": 4568,
    "等{}人执行": 4569,
    "新建Word": 4570,
    "新建Excel": 4571,
    "新建PPT": 4572,
    "备注名": 4573,
    "当前已存在{}个名称为{}身份证与当前填写身份证一致的自然人客户{},该客户创建人为{} ，是否创建同名新客户？客户编码将作为该客户唯一标识": 4574,
    "任务类型消息": 4575,
    "聊天记录合集": 4576,
    "日志类型消息": 4577,
    "语音消息": 4578,
    "图文消息": 4579,
    "{}（{}人）": 4580,
    "您的设备暂不支持此功能，请使用文件或文件夹分别上传": 4581,
    "系统将为您检测是否安装过荣大XB插件，如果您没有安装过XB插件将为您自动安装，待安装后需您继续点击对应项目“数据中心”进行业务类型操作。": 4582,
    "文件上传准备中，请耐心等待...": 4583,
    "系统设置": 4584,
    "搜索({})": 4585,
    "文件正在回传，请稍后重试": 4586,
    "传输列表工作中也可关闭继续其他操作": 4587,
    "任务概览暂不支持下载文件夹": 4588,
    "外链分享记录": 4589,
    "文件分享记录": 4590,
    "银行流水线上平台": 4591,
    "银行流水线上平台权限": 4592,
    "有权在项目文档与底稿视图中查看该项目下的所有外链分享记录，同时拥有取消全部外链分享的权限": 4593,
    "解析权限": 4594,
    "可以对文件进行开始解析、暂停解析": 4595,
    "校对权限": 4596,
    "可以对文件进行校对、导出": 4597,
    "外链权限设置": 4598,
    "通过分享外链的「权限设置」功能，可以设置外链的「过期时间」、「访问密码」、「下载权限」": 4599,
    "在「外链分享记录」中，可查看历史外链详情，也可取消分享": 4600,
    "分享二维码": 4601,
    "已含有访问密码，扫码后无需再次输入": 4602,
    "文件外链：": 4603,
    "{} 通过「荣大智慧云」将“{}”文件分享给你，点击链接进行查看。{}": 4604,
    "{} 通过「荣大智慧云」将“{}”等文件分享给你，点击链接进行查看。{}": 4605,
    "{}\\n访问密码：{}": 4606,
    "已经加载到底啦": 4607,
    "过期时间": 4608,
    "7天": 4609,
    "30天": 4610,
    "永久有效": 4611,
    "共选择{}个文件": 4612,
    "访问密码": 4613,
    "无访问密码": 4614,
    "有访问密码": 4615,
    "系统默认生成访问密码": 4616,
    "下载权限": 4617,
    "允许下载": 4618,
    "禁止下载": 4619,
    "获得该文档链接的用户都可访问分享的相关文档": 4620,
    "链接有效期：": 4621,
    "访问密码：": 4622,
    "所有获得链接的用户都可查看": 4623,
    "到期后将无法访问此链接": 4624,
    "确定要进入「银行流水线上平台」吗？": 4625,
    "取消该文件的外链分享": 4626,
    "文件外链": 4627,
    "分享时间": 4628,
    "取消分享": 4629,
    "确定要取消外链分享吗？": 4630,
    "取消后在该外链中将无法查看此文件，确定要继续操作吗？": 4631,
    "取消后链接将全部失效，确定要继续操作吗？": 4632,
    "取消成功": 4633,
    "{} 访问密码：{}": 4634,
    "请输入操作人名称": 4635,
    "取消全部外链分享": 4636,
    "数量": 4637,
    "取消分享后拥有该链接的用户将无法继续查看分享的文件内容，确定要取消分享吗？": 4638,
    "是否通知执行人和抄送人?": 4639,
    "因当前空间不足，导致文件上传失败，请清理空间后重试。": 4640,
    "港股翻译": 4641,
    "IT数据中台线上平台": 4642,
    "管理员权限": 4643,
    "可以对文档进行校对、预览": 4644,
    "预览校对权限": 4645,
    "可以对文件进行校对、编辑、预览、导出": 4646,
    "文件名称暂不支持查看": 4647,
    "确定要进入「港股翻译」平台吗？": 4648,
    "确定要进入「IT数据中台线上平台」吗？": 4649,
    "项目属性": 4650,
    "请选择项目属性": 4651,
    "标签变动记录": 4652,
    "产品到期提醒": 4653,
    "前往充值": 4654,
    "会议已删除": 4655,
    "投票已删除": 4656,
    "正在加载，请稍等": 4657,
    "排序设置": 4658,
    "按创建时间": 4659,
    "按项目名称": 4660,
    "排序顺序": 4661,
    "倒序": 4662,
    "正序": 4663,
    "评论成功": 4664,
    "确定要删除评论吗？": 4665,
    "删除后将无法恢复，确定要继续删除评论吗？": 4666,
    "回复成功": 4667,
    "选区内容已被删除": 4668,
    "当前多选不支持此操作，请选择单个文件以查看版本": 4669,
    "客户关系": 4670,
    "性格特征": 4671,
    "擅长行业": 4672,
    "综合评价": 4673,
    "请输入客户关系": 4674,
    "请输入性格特征": 4675,
    "请选择擅长行业": 4676,
    "交接时间": 4677,
    "有新内容上线，点击完成更新": 4678,
    "更新信息": 4679,
    "执业岗位": 4680,
    "修改头像": 4681,
    "上传头像": 4682,
    "客户关系不能为空": 4683,
    "性格特征不能为空": 4684,
    "擅长行业不能为空": 4685,
    "YYYY年M月D日": 4686,
    "处理完成map": 4687,
    "查看上下文": 4688,
    "查看全部评论": 4689,
    "输入评论，支持@组织内成员": 4690,
    "任务成员": 4691,
    "IT数据中台项目：项目开通线上流水校对功能和RPA穿行测试功能": 4692,
    "IT数据中台项目": 4693,
    "Enter 发送": 4694,
    "输入内容超出字符限制，请控制在200字符以内": 4695,
    "更新版本时，已上锁文件将自动过滤，不进行重命名或更新": 4696,
    "申请查看联系人方式": 4697,
    "已被拒绝": 4698,
    "已终止授权": 4699,
    "授权有效期": 4700,
    "授权消息": 4701,
    "请选择项目类型": 4702,
    "当前授权已由他人完成": 4703,
    "请选择交易场所": 4704,
    "是否存在效力期限内与该项目有关的负面执业声誉信息": 4705,
    "请输入发行人": 4706,
    "请输入保荐机构": 4707,
    "获取官网数据": 4708,
    "人工录入数据": 4709,
    "新建项目经历": 4710,
    "编辑项目经历": 4711,
    "板块": 4712,
    "确定要删除该项目经历吗？": 4713,
    "联系人姓名:": 4714,
    "举报类型": 4715,
    "举报说明": 4716,
    "盗版、未获得权利人的合法授权": 4717,
    "举报成功": 4718,
    "可使用只读打开。确定要继续预览打开吗？": 4719,
    "下载可查看完整文件。确定要继续预览打开吗？": 4720,
    "安全中心": 4721,
    "已认证": 4722,
    "认证已过期": 4723,
    "您的实名认证已通过，有效期为": 4724,
    "注：认证到期或信息变更时，需要重新认证": 4725,
    "证件类型": 4726,
    "身份证": 4727,
    "更新认证": 4728,
    "立即认证": 4729,
    "真实姓名": 4730,
    "解绑": 4731,
    "证件证号": 4732,
    "请输入真实姓名": 4733,
    "请输入证件证号": 4734,
    "证件证号格式不正确，请检查后重新输入": 4735,
    "台湾来往大陆通行证": 4736,
    "港澳来往大陆通行证": 4737,
    "护照": 4738,
    "认证成功": 4739,
    "设置实名认证": 4740,
    "为满足监管要求，保障共享文件服务的安全合规，请进行实名认证以解锁全部功能": 4741,
    "关闭弹框后将退出登录，确定要取消实名认证吗？": 4742,
    "账号保护": 4743,
    "认证有效期": 4744,
    "申诉举报": 4745,
    "投诉举报": 4746,
    "未认证": 4747,
    "已过期": 4748,
    "本地编辑将调用本地对应文件的编辑器打开": 4749,
    "显示为「仅可预览」或「不可预览」的文件格式，不支持本地编辑": 4750,
    "验证失败，请重试": 4751,
    "填写信息": 4752,
    "认证完成": 4753,
    "如有问题，请拨打咨询电话-": 4754,
    "完成时间": 4755,
    "已显示全部子任务": 4756,
    "共 {} 项文件已全部显示": 4757,
    "审核期间可正常使用系统": 4758,
    "根据国家监管机构下发的相关监管要求，您提交的手机号疑似虚拟号码，我们将对您提交的信息进行人工审核，在此期间，您可以正常使用系统，若有监管审核需要，我们会及时与您联系核验信息，请您知晓": 4759,
    "\"{}\"正在进行在线编辑，于\"{}\"发起": 4760,
    "【图片】": 4761,
    "请选择任务标签": 4762,
    "动态提醒": 4763,
    "请选择动态提醒": 4764,
    "请输入任务内容,多个请用空格隔开": 4765,
    "当 更新时间": 4766,
    "且 操作人员": 4767,
    "且 操作内容": 4768,
    "请输入操作内容": 4769,
    "字段配置": 4770,
    "新增字段配置": 4771,
    "补充更多任务维度字段，可按需勾选展示字段，灵活自定义任务列表，聚焦关注信息": 4772,
    "好的": 4773,
    "任务创建时间": 4774,
    "精准筛选任务，多条件组合快速定位所需": 4775,
    "将为本项目开启IT数据中台功能": 4776,
    "可访问数据（荣大专用）": 4777,
    "任务新动态，在名称后红点提示": 4778,
    "无项目": 4779
}